var Wi = Object.defineProperty, Yi = Object.defineProperties;
var Ki = Object.getOwnPropertyDescriptors;
var Xe = Object.getOwnPropertySymbols;
var Dr = Object.prototype.hasOwnProperty, Mr = Object.prototype.propertyIsEnumerable;
var Lt = (e, t, r) => t in e ? Wi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, D = (e, t) => {
  for (var r in t || (t = {}))
    Dr.call(t, r) && Lt(e, r, t[r]);
  if (Xe)
    for (var r of Xe(t))
      Mr.call(t, r) && Lt(e, r, t[r]);
  return e;
}, F = (e, t) => Yi(e, Ki(t));
var It = (e, t) => {
  var r = {};
  for (var n in e)
    Dr.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && Xe)
    for (var n of Xe(e))
      t.indexOf(n) < 0 && Mr.call(e, n) && (r[n] = e[n]);
  return r;
};
var S = (e, t, r) => Lt(e, typeof t != "symbol" ? t + "" : t, r);
var H = (e, t, r) => new Promise((n, i) => {
  var o = (u) => {
    try {
      s(r.next(u));
    } catch (c) {
      i(c);
    }
  }, a = (u) => {
    try {
      s(r.throw(u));
    } catch (c) {
      i(c);
    }
  }, s = (u) => u.done ? n(u.value) : Promise.resolve(u.value).then(o, a);
  s((r = r.apply(e, t)).next());
});
const Ji = ({ apiKey: e }) => {
  (function(t, r) {
    var n = t.amplitude || { _q: [], _iq: {} }, i = r.createElement("script");
    i.type = "text/javascript", i.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", i.crossOrigin = "anonymous", i.async = !0, i.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", i.onload = function() {
      t.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(e);
    };
    var o = r.getElementsByTagName("script")[0];
    o.parentNode.insertBefore(i, o);
    function a(p, v) {
      p.prototype[v] = function() {
        return this._q.push([v].concat(Array.prototype.slice.call(arguments, 0))), this;
      };
    }
    for (var s = function() {
      return this._q = [], this;
    }, u = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], c = 0; c < u.length; c++)
      a(s, u[c]);
    n.Identify = s;
    for (var l = function() {
      return this._q = [], this;
    }, f = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], d = 0; d < f.length; d++)
      a(l, f[d]);
    n.Revenue = l;
    var h = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function _(p) {
      function v(O) {
        p[O] = function() {
          p._q.push([O].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      for (var g = 0; g < h.length; g++)
        v(h[g]);
    }
    _(n), n.getInstance = function(p) {
      return p = (!p || p.length === 0 ? "$default_instance" : p).toLowerCase(), Object.prototype.hasOwnProperty.call(n._iq, p) || (n._iq[p] = { _q: [] }, _(n._iq[p])), n._iq[p];
    }, t.amplitude = n;
  })(window, document);
}, Qi = ({ projectToken: e }) => {
  if (window.mixpanel)
    return;
  (function(r, n) {
    if (!n.__SV) {
      var i, o;
      window.mixpanel = n, n._i = [], n.init = function(a, s, u) {
        function c(d, h) {
          var _ = h.split(".");
          _.length == 2 && (d = d[_[0]], h = _[1]), d[h] = function() {
            d.push([h].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var l = n;
        for (typeof u != "undefined" ? l = n[u] = [] : u = "mixpanel", l.people = l.people || [], l.toString = function(d) {
          var h = "mixpanel";
          return u !== "mixpanel" && (h += "." + u), d || (h += " (stub)"), h;
        }, l.people.toString = function() {
          return l.toString(1) + ".people (stub)";
        }, i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "), o = 0; o < i.length; o++)
          c(l, i[o]);
        var f = "set set_once union unset remove delete".split(" ");
        l.get_group = function() {
          function d(v) {
            h[v] = function() {
              call2_args = arguments, call2 = [v].concat(Array.prototype.slice.call(call2_args, 0)), l.push([_, call2]);
            };
          }
          for (var h = {}, _ = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), p = 0; p < f.length; p++)
            d(f[p]);
          return h;
        }, n._i.push([a, s, u]);
      }, n.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const t = document.createElement("script");
  t.src = Zi, document.head.appendChild(t), t.addEventListener("load", () => {
    var r;
    (r = window.mixpanel) == null || r.init(e);
  });
}, Zi = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js", Tf = 1e3, mf = 2e3, yf = 144e5;
const Sf = {
  normal: {
    bytes: 1e7,
    time: 24e4
  },
  canvas: {
    bytes: 16e6,
    time: 5e3
  }
}, Of = 100, eo = "app.highlight.io";
var An = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function bn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Nn = { exports: {} }, Ct = { exports: {} }, Ur;
function to() {
  return Ur || (Ur = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(An, function() {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], s = ["fileName", "functionName", "source"], u = ["args"], c = ["evalOrigin"], l = o.concat(a, s, u, c);
      function f(p) {
        if (p)
          for (var v = 0; v < l.length; v++)
            p[l[v]] !== void 0 && this["set" + n(l[v])](p[l[v]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof f)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new f(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", v = this.getLineNumber() || "", g = this.getColumnNumber() || "", O = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + v + ":" + g + ")" : "[eval]:" + v + ":" + g : O ? O + " (" + p + ":" + v + ":" + g + ")" : p + ":" + v + ":" + g;
        }
      }, f.fromString = function(v) {
        var g = v.indexOf("("), O = v.lastIndexOf(")"), I = v.substring(0, g), B = v.substring(g + 1, O).split(","), N = v.substring(O + 1);
        if (N.indexOf("@") === 0)
          var M = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(N, ""), te = M[1], Ge = M[2], Oe = M[3];
        return new f({
          functionName: I,
          args: B || void 0,
          fileName: te,
          lineNumber: Ge || void 0,
          columnNumber: Oe || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = !!v;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        f.prototype["get" + n(a[h])] = i(a[h]), f.prototype["set" + n(a[h])] = /* @__PURE__ */ function(p) {
          return function(v) {
            if (!r(v))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(v);
          };
        }(a[h]);
      for (var _ = 0; _ < s.length; _++)
        f.prototype["get" + n(s[_])] = i(s[_]), f.prototype["set" + n(s[_])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = String(v);
          };
        }(s[_]);
      return f;
    });
  }(Ct)), Ct.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(to());
  })(An, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(u) {
        if (typeof u.stacktrace != "undefined" || typeof u["opera#sourceloc"] != "undefined")
          return this.parseOpera(u);
        if (u.stack && u.stack.match(o))
          return this.parseV8OrIE(u);
        if (u.stack)
          return this.parseFFOrSafari(u);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(u) {
        if (u.indexOf(":") === -1)
          return [u];
        var c = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = c.exec(u.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(u) {
        var c = u.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return c.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var h = f.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, v = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: p,
            fileName: v,
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(u) {
        var c = u.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return c.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), h = d && d[1] ? d[1] : void 0, _ = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: h,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(u) {
        return !u.stacktrace || u.message.indexOf(`
`) > -1 && u.message.split(`
`).length > u.stacktrace.split(`
`).length ? this.parseOpera9(u) : u.stack ? this.parseOpera11(u) : this.parseOpera10(u);
      },
      parseOpera9: function(u) {
        for (var c = /Line (\d+).*script (?:in )?(\S+)/i, l = u.message.split(`
`), f = [], d = 2, h = l.length; d < h; d += 2) {
          var _ = c.exec(l[d]);
          _ && f.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(u) {
        for (var c = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = u.stacktrace.split(`
`), f = [], d = 0, h = l.length; d < h; d += 2) {
          var _ = c.exec(l[d]);
          _ && f.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(u) {
        var c = u.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return c.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), h = f.shift() || "", _ = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var v = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: _,
            args: v,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(Nn);
var ro = Nn.exports;
const it = /* @__PURE__ */ bn(ro);
function no(e, t, r) {
  try {
    if (!(t in e))
      return () => {
      };
    const n = e[t], i = r(n);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), e[t] = i, () => {
      e[t] = n;
    };
  } catch (n) {
    return () => {
    };
  }
}
function io(e) {
  if (!e || !e.outerHTML)
    return "";
  let t = "";
  for (; e.parentElement; ) {
    let r = e.localName;
    if (!r)
      break;
    r = r.toLowerCase();
    let n = e.parentElement, i = [];
    if (n.children && n.children.length > 0)
      for (let o = 0; o < n.children.length; o++) {
        let a = n.children[o];
        a.localName && a.localName.toLowerCase && a.localName.toLowerCase() === r && i.push(a);
      }
    i.length > 1 && (r += ":eq(" + i.indexOf(e) + ")"), t = r + (t ? ">" + t : ""), e = n;
  }
  return t;
}
function Zt(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function wn(e, t) {
  if (t === 0)
    return !0;
  const r = Object.keys(e);
  for (const n of r)
    if (Zt(e[n]) && wn(e[n], t - 1))
      return !0;
  return !1;
}
function Pt(e, t) {
  const r = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(r, t);
  const n = [], i = [];
  return JSON.stringify(e, function(s, u) {
    if (n.length > 0) {
      const c = n.indexOf(this);
      ~c ? n.splice(c + 1) : n.push(this), ~c ? i.splice(c, 1 / 0, s) : i.push(s), ~n.indexOf(u) && (n[0] === u ? u = "[Circular ~]" : u = "[Circular ~." + i.slice(0, n.indexOf(u)).join(".") + "]");
    } else
      n.push(u);
    if (u == null)
      return u;
    if (o(u))
      return a(u);
    if (u instanceof Event) {
      const c = {};
      for (const l in u) {
        const f = u[l];
        Array.isArray(f) ? c[l] = io(f.length ? f[0] : null) : c[l] = f;
      }
      return c;
    } else {
      if (u instanceof Node)
        return u instanceof HTMLElement ? u ? u.outerHTML : "" : u.nodeName;
      if (u instanceof Error)
        return u.name + ": " + u.message;
    }
    return u;
  });
  function o(s) {
    return Zt(s) && Object.keys(s).length > r.numOfKeysLimit || typeof s == "function" ? !0 : s instanceof Event && s.isTrusted === !1 ? Object.keys(s).length === 1 : !!(Zt(s) && wn(s, r.depthOfLimit));
  }
  function a(s) {
    let u = s.toString();
    return r.stringLengthLimit && u.length > r.stringLengthLimit && (u = `${u.slice(0, r.stringLengthLimit)}...`), u;
  }
}
function oo() {
  var e = document.createElement("canvas");
  return e.getContext && e.getContext("2d") ? e.toDataURL("image/webp").indexOf("data:image/webp") == 0 : !1;
}
function Rf() {
  return oo() ? {
    type: "image/webp",
    quality: 0.9
  } : {
    type: "image/jpeg",
    quality: 0.6
  };
}
function ao(e, t) {
  const r = t.logger;
  let n;
  n = window[r];
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (s) => {
      const { message: u, error: c } = s;
      let l = [];
      c && (l = it.parse(c));
      const f = [
        Pt(u, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, s) {
    return a[s] ? no(a, s, (u) => (...c) => {
      u.apply(this, c);
      try {
        const l = it.parse(new Error()), f = t.serializeConsoleAttributes ? c.map((d) => typeof d == "object" ? Pt(d, t.stringifyOptions) : d) : c.filter((d) => typeof d != "object").map((d) => `${d}`);
        e({
          type: s,
          trace: l.slice(1),
          value: f,
          attributes: Pt(c.filter((d) => typeof d == "object").reduce((d, h) => D(D({}, d), h), {}), t.stringifyOptions),
          time: Date.now()
        });
      } catch (l) {
        u("highlight logger error:", l, ...c);
      }
    }) : () => {
    };
  }
}
var er = { exports: {} };
(function(e, t) {
  t = e.exports = r, t.getSerialize = n;
  function r(i, o, a, s) {
    return JSON.stringify(i, n(o, s), a);
  }
  function n(i, o) {
    var a = [], s = [];
    return o == null && (o = function(u, c) {
      return a[0] === c ? "[Circular ~]" : "[Circular ~." + s.slice(0, a.indexOf(c)).join(".") + "]";
    }), function(u, c) {
      if (a.length > 0) {
        var l = a.indexOf(this);
        ~l ? a.splice(l + 1) : a.push(this), ~l ? s.splice(l, 1 / 0, u) : s.push(u), ~a.indexOf(c) && (c = o.call(this, u, c));
      } else a.push(c);
      return i == null ? c : i.call(this, u, c);
    };
  }
})(er, er.exports);
var so = er.exports;
const ot = /* @__PURE__ */ bn(so);
function xt(e, t, r, n) {
  var s, u, c, l;
  let i = [];
  try {
    i = it.parse(n != null ? n : t);
  } catch (f) {
    i = it.parse(new Error());
  }
  let o = {};
  t instanceof Error && (t = t.message, t.cause && (o = { "exception.cause": t.cause }));
  const a = co(i);
  e({
    event: ot(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (s = a[0]) != null && s.lineNumber ? (u = a[0]) == null ? void 0 : u.lineNumber : 0,
    columnNumber: (c = a[0]) != null && c.columnNumber ? (l = a[0]) == null ? void 0 : l.columnNumber : 0,
    stackTrace: a,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: o ? ot(o) : void 0
  });
}
const uo = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined")
    return () => {
    };
  const r = window.onerror = (a, s, u, c, l) => {
    xt(e, a, s, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const s = a.promise;
      s.getStack ? xt(e, a.reason, a.type, s.getStack()) : xt(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(u) {
      super(u);
      S(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const u = typeof window.Zone == "undefined";
      return t && u;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, co = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Br = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Fr = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var lo = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ue = "1.9.0", Hr = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function fo(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(Hr);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(u) {
      return u === e;
    };
  function o(s) {
    return r.add(s), !1;
  }
  function a(s) {
    return t.add(s), !0;
  }
  return function(u) {
    if (t.has(u))
      return !0;
    if (r.has(u))
      return !1;
    var c = u.match(Hr);
    if (!c)
      return o(u);
    var l = {
      major: +c[1],
      minor: +c[2],
      patch: +c[3],
      prerelease: c[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(u) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(u) : o(u) : i.minor <= l.minor ? a(u) : o(u);
  };
}
var po = fo(ue), ho = ue.split(".")[0], Me = Symbol.for("opentelemetry.js.api." + ho), Ue = lo;
function He(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = Ue[Me] = (i = Ue[Me]) !== null && i !== void 0 ? i : {
    version: ue
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== ue) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + ue);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + ue + "."), !0;
}
function fe(e) {
  var t, r, n = (t = Ue[Me]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !po(n)))
    return (r = Ue[Me]) === null || r === void 0 ? void 0 : r[e];
}
function je(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + ue + ".");
  var r = Ue[Me];
  r && delete r[e];
}
var _o = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Eo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, vo = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Re("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Re("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Re("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Re("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Re("verbose", this._namespace, t);
    }, e;
  }()
);
function Re(e, t, r) {
  var n = fe("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, Eo([], _o(r), !1));
}
var w;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(w || (w = {}));
function go(e, t) {
  e < w.NONE ? e = w.NONE : e > w.ALL && (e = w.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", w.ERROR),
    warn: r("warn", w.WARN),
    info: r("info", w.INFO),
    debug: r("debug", w.DEBUG),
    verbose: r("verbose", w.VERBOSE)
  };
}
var To = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, mo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, yo = "diag", q = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var s = fe("diag");
          if (s)
            return s[i].apply(s, mo([], To(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, s, u;
        if (o === void 0 && (o = { logLevel: w.INFO }), i === r) {
          var c = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = c.stack) !== null && a !== void 0 ? a : c.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = fe("diag"), f = go((s = o.logLevel) !== null && s !== void 0 ? s : w.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (u = new Error().stack) !== null && u !== void 0 ? u : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return He("diag", f, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        je(yo, r);
      }, r.createComponentLogger = function(i) {
        return new vo(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), So = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Oo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ro = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = So(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = Oo(n), s = a.next(); !s.done; s = a.next()) {
          var u = s.value;
          o._entries.delete(u);
        }
      } catch (c) {
        t = { error: c };
      } finally {
        try {
          s && !s.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), Ao = Symbol("BaggageEntryMetadata"), bo = q.instance();
function No(e) {
  return e === void 0 && (e = {}), new Ro(new Map(Object.entries(e)));
}
function wo(e) {
  return typeof e != "string" && (bo.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: Ao,
    toString: function() {
      return e;
    }
  };
}
function gr(e) {
  return Symbol.for(e);
}
var Lo = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), oe = new Lo(), pe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Io = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return Ho;
    }, e.prototype.createHistogram = function(t, r) {
      return jo;
    }, e.prototype.createCounter = function(t, r) {
      return Fo;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return Vo;
    }, e.prototype.createObservableGauge = function(t, r) {
      return Xo;
    }, e.prototype.createObservableCounter = function(t, r) {
      return Go;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return $o;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), Tt = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Co = (
  /** @class */
  function(e) {
    pe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(Tt)
), Po = (
  /** @class */
  function(e) {
    pe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(Tt)
), xo = (
  /** @class */
  function(e) {
    pe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(Tt)
), ko = (
  /** @class */
  function(e) {
    pe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(Tt)
), Tr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), Do = (
  /** @class */
  function(e) {
    pe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Tr)
), Mo = (
  /** @class */
  function(e) {
    pe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Tr)
), Uo = (
  /** @class */
  function(e) {
    pe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Tr)
), Bo = new Io(), Fo = new Co(), Ho = new xo(), jo = new ko(), Vo = new Po(), Go = new Do(), Xo = new Mo(), $o = new Uo(), qo = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, zo = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, Wo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Yo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ko = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return oe;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, Yo([n], Wo(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Jo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Qo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, kt = "context", Zo = new Ko(), mt = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return He(kt, t, q.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, Qo([t, r, n], Jo(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return fe(kt) || Zo;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), je(kt, q.instance());
    }, e;
  }()
), z;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(z || (z = {}));
var Ln = "0000000000000000", In = "00000000000000000000000000000000", Cn = {
  traceId: In,
  spanId: Ln,
  traceFlags: z.NONE
}, Ce = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = Cn), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), mr = gr("OpenTelemetry Context Key SPAN");
function yr(e) {
  return e.getValue(mr) || void 0;
}
function ea() {
  return yr(mt.getInstance().active());
}
function Sr(e, t) {
  return e.setValue(mr, t);
}
function ta(e) {
  return e.deleteValue(mr);
}
function ra(e, t) {
  return Sr(e, new Ce(t));
}
function Pn(e) {
  var t;
  return (t = yr(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var na = /^([0-9a-f]{32})$/i, ia = /^[0-9a-f]{16}$/i;
function xn(e) {
  return na.test(e) && e !== In;
}
function oa(e) {
  return ia.test(e) && e !== Ln;
}
function yt(e) {
  return xn(e.traceId) && oa(e.spanId);
}
function aa(e) {
  return new Ce(e);
}
var Dt = mt.getInstance(), kn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = Dt.active());
      var i = !!(r != null && r.root);
      if (i)
        return new Ce();
      var o = n && Pn(n);
      return sa(o) && yt(o) ? new Ce(o) : new Ce();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, s;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? s = r : arguments.length === 3 ? (o = r, s = n) : (o = r, a = n, s = i);
        var u = a != null ? a : Dt.active(), c = this.startSpan(t, o, u), l = Sr(u, c);
        return Dt.with(l, s, void 0, c);
      }
    }, e;
  }()
);
function sa(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var ua = new kn(), ca = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : ua;
    }, e;
  }()
), la = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new kn();
    }, e;
  }()
), fa = new la(), jr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new ca(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : fa;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), at;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(at || (at = {}));
var Be;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(Be || (Be = {}));
var tr;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(tr || (tr = {}));
var R = mt.getInstance(), y = q.instance(), da = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return Bo;
    }, e;
  }()
), pa = new da(), Mt = "metrics", ha = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return He(Mt, t, q.instance());
    }, e.prototype.getMeterProvider = function() {
      return fe(Mt) || pa;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      je(Mt, q.instance());
    }, e;
  }()
), Dn = ha.getInstance(), _a = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), Or = gr("OpenTelemetry Baggage Key");
function Mn(e) {
  return e.getValue(Or) || void 0;
}
function Ea() {
  return Mn(mt.getInstance().active());
}
function va(e, t) {
  return e.setValue(Or, t);
}
function ga(e) {
  return e.deleteValue(Or);
}
var Ut = "propagation", Ta = new _a(), ma = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = No, this.getBaggage = Mn, this.getActiveBaggage = Ea, this.setBaggage = va, this.deleteBaggage = ga;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return He(Ut, t, q.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = zo), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = qo), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      je(Ut, q.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return fe(Ut) || Ta;
    }, e;
  }()
), j = ma.getInstance(), Bt = "trace", ya = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new jr(), this.wrapSpanContext = aa, this.isSpanContextValid = yt, this.deleteSpan = ta, this.getSpan = yr, this.getActiveSpan = ea, this.getSpanContext = Pn, this.setSpan = Sr, this.setSpanContext = ra;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = He(Bt, this._proxyTracerProvider, q.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return fe(Bt) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      je(Bt, q.instance()), this._proxyTracerProvider = new jr();
    }, e;
  }()
), b = ya.getInstance(), Un = gr("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Bn(e) {
  return e.setValue(Un, !0);
}
function Rr(e) {
  return e.getValue(Un) === !0;
}
var Sa = "=", rr = ";", st = ",", Ft = "baggage", Oa = 180, Ra = 4096, Aa = 8192, ba = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Na(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? st : "") + r;
    return n.length > Aa ? t : n;
  }, "");
}
function wa(e) {
  return e.getAllEntries().map(function(t) {
    var r = ba(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += rr + i.metadata.toString()), o;
  });
}
function Fn(e) {
  var t = e.split(rr);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Sa);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = wo(t.join(rr))), { key: i, value: o, metadata: a };
      }
    }
  }
}
function Hn(e) {
  return typeof e != "string" || e.length === 0 ? {} : e.split(st).map(function(t) {
    return Fn(t);
  }).filter(function(t) {
    return t !== void 0 && t.value.length > 0;
  }).reduce(function(t, r) {
    return t[r.key] = r.value, t;
  }, {});
}
var jn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = j.getBaggage(t);
      if (!(!i || Rr(t))) {
        var o = wa(i).filter(function(s) {
          return s.length <= Ra;
        }).slice(0, Oa), a = Na(o);
        a.length > 0 && n.set(r, Ft, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Ft), o = Array.isArray(i) ? i.join(st) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var s = o.split(st);
      return s.forEach(function(u) {
        var c = Fn(u);
        if (c) {
          var l = { value: c.value };
          c.metadata && (l.metadata = c.metadata), a[c.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : j.setBaggage(t, j.createBaggage(a));
    }, e.prototype.fields = function() {
      return [Ft];
    }, e;
  }()
), Vn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, La = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ze(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = Vn(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = La(o.value, 2), s = a[0], u = a[1];
      if (!Ia(s)) {
        y.warn("Invalid attribute key: " + s);
        continue;
      }
      if (!Gn(u)) {
        y.warn("Invalid attribute value set for key: " + s);
        continue;
      }
      Array.isArray(u) ? n[s] = u.slice() : n[s] = u;
    }
  } catch (c) {
    t = { error: c };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Ia(e) {
  return typeof e == "string" && e.length > 0;
}
function Gn(e) {
  return e == null ? !0 : Array.isArray(e) ? Ca(e) : Xn(e);
}
function Ca(e) {
  var t, r, n;
  try {
    for (var i = Vn(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (Xn(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function Xn(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Pa() {
  return function(e) {
    y.error(xa(e));
  };
}
function xa(e) {
  return typeof e == "string" ? e : JSON.stringify(ka(e));
}
function ka(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Da = Pa();
function le(e) {
  try {
    Da(e);
  } catch (t) {
  }
}
var $;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})($ || ($ = {}));
var Ma = ",", Ua = ["OTEL_SDK_DISABLED"];
function Ba(e) {
  return Ua.indexOf(e) > -1;
}
var Fa = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Ha(e) {
  return Fa.indexOf(e) > -1;
}
var ja = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS"
];
function Va(e) {
  return ja.indexOf(e) > -1;
}
var et = 1 / 0, tt = 128, Ga = 128, Xa = 128, $n = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: w.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: et,
  OTEL_ATTRIBUTE_COUNT_LIMIT: tt,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: et,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: tt,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: et,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: tt,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Ga,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Xa,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: $.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
function $a(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function qa(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function za(e, t, r, n) {
  n === void 0 && (n = Ma);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var Wa = {
  ALL: w.ALL,
  VERBOSE: w.VERBOSE,
  DEBUG: w.DEBUG,
  INFO: w.INFO,
  WARN: w.WARN,
  ERROR: w.ERROR,
  NONE: w.NONE
};
function Ya(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = Wa[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function qn(e) {
  var t = {};
  for (var r in $n) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Ya(n, t, e);
        break;
      default:
        if (Ba(n))
          $a(n, t, e);
        else if (Ha(n))
          qa(n, t, e);
        else if (Va(n))
          za(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var Pe = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function L() {
  var e = qn(Pe);
  return Object.assign({}, $n, e);
}
function Ka() {
  return qn(Pe);
}
function Vr(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function Ar(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = Vr(e.charCodeAt(n)), o = Vr(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var V = performance, Ja = "1.25.1", Qa = "exception.type", Za = "exception.message", es = "exception.stacktrace", ts = "http.method", rs = "http.url", ns = "http.host", is = "http.scheme", os = "http.status_code", as = "http.user_agent", ss = "http.response_content_length", us = "http.response_content_length_uncompressed", Ht = Qa, jt = Za, cs = es, zn = ts, xe = rs, Wn = ns, Yn = is, Kn = os, br = as, ls = ss, fs = us, ds = "deployment.environment", ps = "process.runtime.name", hs = "service.name", _s = "telemetry.sdk.name", Es = "telemetry.sdk.language", vs = "telemetry.sdk.version", gs = ds, Ts = ps, Jn = hs, nr = _s, ir = Es, or = vs, ms = "webjs", ys = ms, he, Vt = (he = {}, he[nr] = "opentelemetry", he[Ts] = "browser", he[ir] = ys, he[or] = Ja, he), Ss = 9, Os = 6, Rs = Math.pow(10, Os), ut = Math.pow(10, Ss);
function Q(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Rs);
  return [r, n];
}
function Nr() {
  var e = V.timeOrigin;
  if (typeof e != "number") {
    var t = V;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function ge(e) {
  var t = Q(Nr()), r = Q(typeof e == "number" ? e : V.now());
  return Qn(t, r);
}
function ke(e) {
  if (wr(e))
    return e;
  if (typeof e == "number")
    return e < Nr() ? ge(e) : Q(e);
  if (e instanceof Date)
    return Q(e.getTime());
  throw TypeError("Invalid input type");
}
function As(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += ut), [r, n];
}
function Z(e) {
  return e[0] * ut + e[1];
}
function Gr(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function wr(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Xr(e) {
  return wr(e) || typeof e == "number" || e instanceof Date;
}
function Qn(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= ut && (r[1] -= ut, r[0] += 1), r;
}
var ee;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(ee || (ee = {}));
var bs = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Zn = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = bs(this._propagators), s = a.next(); !s.done; s = a.next()) {
          var u = s.value;
          try {
            u.inject(t, r, n);
          } catch (c) {
            y.warn("Failed to inject with " + u.constructor.name + ". Err: " + c.message);
          }
        }
      } catch (c) {
        i = { error: c };
      } finally {
        try {
          s && !s.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          y.warn("Failed to inject with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), ar = "[_0-9a-z-*/]", Ns = "[a-z]" + ar + "{0,255}", ws = "[a-z0-9]" + ar + "{0,240}@[a-z]" + ar + "{0,13}", Ls = new RegExp("^(?:" + Ns + "|" + ws + ")$"), Is = /^[ -~]{0,255}[!-~]$/, Cs = /,|=/;
function Ps(e) {
  return Ls.test(e);
}
function xs(e) {
  return Is.test(e) && !Cs.test(e);
}
var $r = 32, ks = 512, qr = ",", zr = "=", Ds = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + zr + t.get(n)), r;
      }, []).join(qr);
    }, e.prototype._parse = function(t) {
      t.length > ks || (this._internalState = t.split(qr).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(zr);
        if (o !== -1) {
          var a = i.slice(0, o), s = i.slice(o + 1, n.length);
          Ps(a) && xs(s) && r.set(a, s);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > $r && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, $r))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), rt = "traceparent", Gt = "tracestate", Ms = "00", Us = "(?!ff)[\\da-f]{2}", Bs = "(?![0]{32})[\\da-f]{32}", Fs = "(?![0]{16})[\\da-f]{16}", Hs = "[\\da-f]{2}", js = new RegExp("^\\s?(" + Us + ")-(" + Bs + ")-(" + Fs + ")-(" + Hs + ")(-.*)?\\s?$");
function Vs(e) {
  var t = js.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var ei = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = b.getSpanContext(t);
      if (!(!i || Rr(t) || !yt(i))) {
        var o = Ms + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || z.NONE).toString(16);
        n.set(r, rt, o), i.traceState && n.set(r, Gt, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, rt);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = Vs(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var s = n.get(r, Gt);
      if (s) {
        var u = Array.isArray(s) ? s.join(",") : s;
        a.traceState = new Ds(typeof u == "string" ? u : void 0);
      }
      return b.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [rt, Gt];
    }, e;
  }()
), Gs = "[object Object]", Xs = "[object Null]", $s = "[object Undefined]", qs = Function.prototype, ti = qs.toString, zs = ti.call(Object), Ws = Ys(Object.getPrototypeOf, Object), ri = Object.prototype, ni = ri.hasOwnProperty, ae = Symbol ? Symbol.toStringTag : void 0, ii = ri.toString;
function Ys(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Wr(e) {
  if (!Ks(e) || Js(e) !== Gs)
    return !1;
  var t = Ws(e);
  if (t === null)
    return !0;
  var r = ni.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && ti.call(r) === zs;
}
function Ks(e) {
  return e != null && typeof e == "object";
}
function Js(e) {
  return e == null ? e === void 0 ? $s : Xs : ae && ae in Object(e) ? Qs(e) : Zs(e);
}
function Qs(e) {
  var t = ni.call(e, ae), r = e[ae], n = !1;
  try {
    e[ae] = void 0, n = !0;
  } catch (o) {
  }
  var i = ii.call(e);
  return n && (t ? e[ae] = r : delete e[ae]), i;
}
function Zs(e) {
  return ii.call(e);
}
var eu = 20;
function tu() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = oi(r, e.shift(), 0, n);
  return r;
}
function Xt(e) {
  return ct(e) ? e.slice() : e;
}
function oi(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > eu)) {
    if (r++, nt(e) || nt(t) || ai(t))
      i = Xt(t);
    else if (ct(e)) {
      if (i = e.slice(), ct(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Xt(t[o]));
      else if (Ae(t))
        for (var s = Object.keys(t), o = 0, a = s.length; o < a; o++) {
          var u = s[o];
          i[u] = Xt(t[u]);
        }
    } else if (Ae(e))
      if (Ae(t)) {
        if (!ru(e, t))
          return t;
        i = Object.assign({}, e);
        for (var s = Object.keys(t), o = 0, a = s.length; o < a; o++) {
          var u = s[o], c = t[u];
          if (nt(c))
            typeof c == "undefined" ? delete i[u] : i[u] = c;
          else {
            var l = i[u], f = c;
            if (Yr(e, u, n) || Yr(t, u, n))
              delete i[u];
            else {
              if (Ae(l) && Ae(f)) {
                var d = n.get(l) || [], h = n.get(f) || [];
                d.push({ obj: e, key: u }), h.push({ obj: t, key: u }), n.set(l, d), n.set(f, h);
              }
              i[u] = oi(i[u], c, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Yr(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function ct(e) {
  return Array.isArray(e);
}
function ai(e) {
  return typeof e == "function";
}
function Ae(e) {
  return !nt(e) && !ct(e) && !ai(e) && typeof e == "object";
}
function nt(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function ru(e, t) {
  return !(!Wr(e) || !Wr(t));
}
var nu = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function si(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function ui(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = nu(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (si(e, a))
        return !0;
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var iu = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), ou = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, au = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Lr = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new iu();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, au([this._that], ou(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
);
function su(e, t) {
  return new Promise(function(r) {
    R.with(Bn(R.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var uu = {
  _export: su
}, cu = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), lu = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new cu();
    }, e;
  }()
), Kr = new lu(), fu = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, $e = Symbol.for("io.opentelemetry.js.api.logs"), be = fu;
function du(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var Jr = 1, pu = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return be[$e] ? this.getLoggerProvider() : (be[$e] = du(Jr, t, Kr), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = be[$e]) === null || t === void 0 ? void 0 : t.call(be, Jr)) !== null && r !== void 0 ? r : Kr;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete be[$e];
    }, e;
  }()
), ci = pu.getInstance();
function hu(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function _u(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function Eu(e) {
  var t, r, n = e.tracerProvider || b.getTracerProvider(), i = e.meterProvider || Dn.getMeterProvider(), o = e.loggerProvider || ci.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return hu(a, n, i, o), function() {
    _u(a);
  };
}
function sr(e) {
  return typeof e == "function";
}
var U = console.error.bind(console);
function Ne(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function Ve(e) {
  e && e.logger && (sr(e.logger) ? U = e.logger : U("new logger isn't a function, not replacing"));
}
function li(e, t, r) {
  if (!e || !e[t]) {
    U("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    U("no wrapper function"), U(new Error().stack);
    return;
  }
  if (!sr(e[t]) || !sr(r)) {
    U("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return Ne(i, "__original", n), Ne(i, "__unwrap", function() {
    e[t] === i && Ne(e, t, n);
  }), Ne(i, "__wrapped", !0), Ne(e, t, i), i;
}
function vu(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    U("must provide one or more modules to patch"), U(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    U("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      li(n, i, r);
    });
  });
}
function fi(e, t) {
  if (!e || !e[t]) {
    U("no function to unwrap."), U(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    U("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function gu(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    U("must provide one or more modules to patch"), U(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    U("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      fi(r, n);
    });
  });
}
Ve.wrap = li;
Ve.massWrap = vu;
Ve.unwrap = fi;
Ve.massUnwrap = gu;
var qe = Ve, lt = function() {
  return lt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, lt.apply(this, arguments);
}, Tu = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._wrap = qe.wrap, this._unwrap = qe.unwrap, this._massWrap = qe.massWrap, this._massUnwrap = qe.massUnwrap, this._config = lt({ enabled: !0 }, n), this._diag = y.createComponentLogger({
        namespace: t
      }), this._tracer = b.getTracer(t, r), this._meter = Dn.getMeter(t, r), this._logger = ci.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = lt({}, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), mu = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), St = (
  /** @class */
  function(e) {
    mu(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Tu)
);
function ft(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    if (t(n, i), n && !r)
      throw n;
    return i;
  }
}
function ce(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var yu = "exception", Su = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qr = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ou = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ru = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, s, u, c, l) {
      s === void 0 && (s = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: tr.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = s;
      var f = Date.now();
      this._performanceStartTime = V.now(), this._performanceOffset = f - (this._performanceStartTime + Nr()), this._startTimeProvided = u != null, this.startTime = this._getTime(u != null ? u : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (y.warn("Invalid attribute key: " + t), this) : Gn(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (y.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = Su(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = Qr(o.value, 2), s = a[0], u = a[1];
          this.setAttribute(s, u);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return y.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && y.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Xr(r) && (Xr(n) || (n = r), r = void 0);
      var i = Ze(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, Ou([], Qr(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = t, this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        y.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = As(this.startTime, this.endTime), this._duration[0] < 0 && (y.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && y.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t < V.now())
        return ge(t + this._performanceOffset);
      if (typeof t == "number")
        return Q(t);
      if (t instanceof Date)
        return Q(t.getTime());
      if (wr(t))
        return t;
      if (this._startTimeProvided)
        return Q(Date.now());
      var r = V.now() - this._performanceStartTime;
      return Qn(this.startTime, Q(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[jt] = t : t && (t.code ? n[Ht] = t.code.toString() : t.name && (n[Ht] = t.name), t.message && (n[jt] = t.message), t.stack && (n[cs] = t.stack)), n[Ht] || n[jt] ? this.addEvent(yu, n, r) : y.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && y.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substr(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (y.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), Te;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Te || (Te = {}));
var dt = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Te.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), ve = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Te.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), $t = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (le(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new ve()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new ve(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new dt(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new ve(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new dt();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var s = b.getSpanContext(t);
      return !s || !yt(s) ? this._root.shouldSample(t, r, n, i, o, a) : s.isRemote ? s.traceFlags & z.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : s.traceFlags & z.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), Zr = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: xn(r) && this._accumulate(r) < this._upperBound ? Te.RECORD_AND_SAMPLED : Te.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), Au = L(), bu = $.AlwaysOn, _e = 1;
function di() {
  return {
    sampler: pi(Au),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: L().OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: L().OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: L().OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: L().OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: L().OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: L().OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: L().OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: L().OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    }
  };
}
function pi(e) {
  switch (e === void 0 && (e = L()), e.OTEL_TRACES_SAMPLER) {
    case $.AlwaysOn:
      return new ve();
    case $.AlwaysOff:
      return new dt();
    case $.ParentBasedAlwaysOn:
      return new $t({
        root: new ve()
      });
    case $.ParentBasedAlwaysOff:
      return new $t({
        root: new dt()
      });
    case $.TraceIdRatio:
      return new Zr(en(e));
    case $.ParentBasedTraceIdRatio:
      return new $t({
        root: new Zr(en(e))
      });
    default:
      return y.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + bu + '".'), new ve();
  }
}
function en(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return y.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + _e + "."), _e;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (y.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + _e + "."), _e) : t < 0 || t > 1 ? (y.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + _e + "."), _e) : t;
}
function Nu(e) {
  var t = {
    sampler: pi()
  }, r = di(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function wu(e) {
  var t, r, n, i, o, a, s, u, c, l, f, d, h = Object.assign({}, e.spanLimits), _ = Ka();
  return h.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : tt, h.attributeValueLengthLimit = (d = (f = (l = (u = (s = e.spanLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && u !== void 0 ? u : (c = e.generalLimits) === null || c === void 0 ? void 0 : c.attributeValueLengthLimit) !== null && l !== void 0 ? l : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : et, Object.assign({}, e, { spanLimits: h });
}
var Lu = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = L();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new Lr(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (y.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || t.spanContext().traceFlags & z.SAMPLED && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && y.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (y.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, s = o; a < s; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        R.with(Bn(R.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === ee.SUCCESS ? r() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, s = null, u = 0, c = o.length; u < c; u++) {
            var l = o[u];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (s != null || (s = []), s.push(l.resource.waitForAsyncAttributes()));
          }
          s === null ? a() : Promise.all(s).then(a, function(f) {
            le(f), n(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, le(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Iu = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), hi = (
  /** @class */
  function(e) {
    Iu(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush();
      }, this._pageHideListener = function() {
        n.forceFlush();
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(Lu)
), Cu = 8, Pu = 16, xu = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = tn(Pu), this.generateSpanId = tn(Cu);
    }
    return e;
  }()
), ze = Array(32);
function tn(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      ze[r] = Math.floor(Math.random() * 16) + 48, ze[r] >= 58 && (ze[r] += 39);
    return String.fromCharCode.apply(null, ze.slice(0, e * 2));
  };
}
var ku = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = Nu(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new xu(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = R.active()), r.root && (n = b.deleteSpan(n));
      var s = b.getSpan(n);
      if (Rr(n)) {
        y.debug("Instrumentation suppressed, returning Noop Span");
        var u = b.wrapSpanContext(Cn);
        return u;
      }
      var c = s == null ? void 0 : s.spanContext(), l = this._idGenerator.generateSpanId(), f, d, h;
      !c || !b.isSpanContextValid(c) ? f = this._idGenerator.generateTraceId() : (f = c.traceId, d = c.traceState, h = c.spanId);
      var _ = (i = r.kind) !== null && i !== void 0 ? i : Be.INTERNAL, p = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(M) {
        return {
          context: M.context,
          attributes: Ze(M.attributes)
        };
      }), v = Ze(r.attributes), g = this._sampler.shouldSample(n, f, t, _, v, p);
      d = (a = g.traceState) !== null && a !== void 0 ? a : d;
      var O = g.decision === at.RECORD_AND_SAMPLED ? z.SAMPLED : z.NONE, I = { traceId: f, spanId: l, traceFlags: O, traceState: d };
      if (g.decision === at.NOT_RECORD) {
        y.debug("Recording is off, propagating context in a non-recording span");
        var u = b.wrapSpanContext(I);
        return u;
      }
      var B = Ze(Object.assign(v, g.attributes)), N = new Ru(this, n, t, I, _, h, p, r.startTime, void 0, B);
      return N;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, s;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? s = r : arguments.length === 3 ? (o = r, s = n) : (o = r, a = n, s = i);
        var u = a != null ? a : R.active(), c = this.startSpan(t, o, u), l = b.setSpan(u, c);
        return R.with(l, s, void 0, c);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
);
function Du() {
  return "unknown_service";
}
var re = function() {
  return re = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, re.apply(this, arguments);
}, Mu = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, Uu = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, Bu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ur = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return y.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[Jn] = Du(), t[ir] = Vt[ir], t[nr] = Vt[nr], t[or] = Vt[or], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && y.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Mu(this, void 0, void 0, function() {
        return Uu(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = re(re({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var s, u = Bu(a, 2), c = u[0], l = u[1];
        return re(re(re(re({}, r._syncAttributes), c), (s = t._syncAttributes) !== null && s !== void 0 ? s : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), We = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Fu = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = We(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(s) {
        Promise.all(n).then(function() {
          s();
        }).catch(function(u) {
          le(u || new Error("MultiSpanProcessor: forceFlush failed")), s();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = We(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          s.onStart(t, r);
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = We(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = We(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(s, u) {
        Promise.all(n).then(function() {
          s();
        }, u);
      });
    }, e;
  }()
), Hu = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), se;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(se || (se = {}));
var ju = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var n = tu({}, di(), wu(t));
      this.resource = (r = n.resource) !== null && r !== void 0 ? r : ur.empty(), this.resource = ur.default().merge(this.resource), this._config = Object.assign({}, n, {
        resource: this.resource
      });
      var i = this._buildExporterFromEnv();
      if (i !== void 0) {
        var o = new hi(i);
        this.activeSpanProcessor = o;
      } else
        this.activeSpanProcessor = new Hu();
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new ku({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return y.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Fu(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), b.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && R.setGlobalContextManager(t.contextManager), t.propagator && j.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = se.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== se.timeout && (o = se.resolved, i(o));
          }).catch(function(s) {
            clearTimeout(a), o = se.error, i(s);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(s) {
            return s !== se.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(L().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || y.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new Zn({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = L().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || y.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new ei();
      }],
      ["baggage", function() {
        return new jn();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), Vu = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Gu = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.export = function(t, r) {
      return this._sendSpans(t, r);
    }, e.prototype.shutdown = function() {
      return this._sendSpans([]), this.forceFlush();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e.prototype._exportInfo = function(t) {
      var r;
      return {
        resource: {
          attributes: t.resource.attributes
        },
        traceId: t.spanContext().traceId,
        parentId: t.parentSpanId,
        traceState: (r = t.spanContext().traceState) === null || r === void 0 ? void 0 : r.serialize(),
        name: t.name,
        id: t.spanContext().spanId,
        kind: t.kind,
        timestamp: Gr(t.startTime),
        duration: Gr(t.duration),
        attributes: t.attributes,
        status: t.status,
        events: t.events,
        links: t.links
      };
    }, e.prototype._sendSpans = function(t, r) {
      var n, i;
      try {
        for (var o = Vu(t), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          console.dir(this._exportInfo(s), { depth: 3 });
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
      if (r)
        return r({ code: ee.SUCCESS });
    }, e;
  }()
), Xu = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, $u = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, qu = (
  /** @class */
  function() {
    function e(t) {
      this._exporter = t, this._shutdownOnce = new Lr(this._shutdown, this), this._unresolvedExports = /* @__PURE__ */ new Set();
    }
    return e.prototype.forceFlush = function() {
      return Xu(this, void 0, void 0, function() {
        return $u(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(Array.from(this._unresolvedExports))];
            case 1:
              return t.sent(), this._exporter.forceFlush ? [4, this._exporter.forceFlush()] : [3, 3];
            case 2:
              t.sent(), t.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      var r = this, n, i;
      if (!this._shutdownOnce.isCalled && t.spanContext().traceFlags & z.SAMPLED) {
        var o = function() {
          return uu._export(r._exporter, [t]).then(function(s) {
            var u;
            s.code !== ee.SUCCESS && le((u = s.error) !== null && u !== void 0 ? u : new Error("SimpleSpanProcessor: span export failed (status " + s + ")"));
          }).catch(function(s) {
            le(s);
          });
        };
        if (t.resource.asyncAttributesPending) {
          var a = (i = (n = t.resource).waitForAsyncAttributes) === null || i === void 0 ? void 0 : i.call(n).then(function() {
            return a != null && r._unresolvedExports.delete(a), o();
          }, function(s) {
            return le(s);
          });
          a != null && this._unresolvedExports.add(a);
        } else
          o();
      }
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      return this._exporter.shutdown();
    }, e;
  }()
), zu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Wu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, _i = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = oe;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = oe);
      var n = this, i = function() {
        for (var o = this, a = [], s = 0; s < arguments.length; s++)
          a[s] = arguments[s];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = oe, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = oe, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || oe;
      try {
        return r.call.apply(r, Wu([n], zu(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), Yu = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ku = (
  /** @class */
  function(e) {
    Yu(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new _i()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(ju)
), m;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(m || (m = {}));
var qt;
function Ju() {
  return qt || (qt = document.createElement("a")), qt;
}
function ie(e, t) {
  return t in e;
}
function x(e, t, r, n) {
  var i = void 0, o = void 0;
  ie(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = m.FETCH_START;
  if (ie(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function me(e, t) {
  x(e, m.FETCH_START, t), x(e, m.DOMAIN_LOOKUP_START, t), x(e, m.DOMAIN_LOOKUP_END, t), x(e, m.CONNECT_START, t), ie(t, "name") && t.name.startsWith("https:") && x(e, m.SECURE_CONNECTION_START, t), x(e, m.CONNECT_END, t), x(e, m.REQUEST_START, t), x(e, m.RESPONSE_START, t), x(e, m.RESPONSE_END, t);
  var r = t[m.ENCODED_BODY_SIZE];
  r !== void 0 && e.setAttribute(ls, r);
  var n = t[m.DECODED_BODY_SIZE];
  n !== void 0 && r !== n && e.setAttribute(fs, n);
}
function Qu(e) {
  return e.slice().sort(function(t, r) {
    var n = t[m.FETCH_START], i = r[m.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function Ei() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function vi(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = K(e);
  e = a.toString();
  var s = ec(e, t, r, n, i, o);
  if (s.length === 0)
    return {
      mainRequest: void 0
    };
  if (s.length === 1)
    return {
      mainRequest: s[0]
    };
  var u = Qu(s);
  if (a.origin !== Ei() && u.length > 1) {
    var c = u[0], l = Zu(u, c[m.RESPONSE_END], r), f = c[m.RESPONSE_END], d = l[m.FETCH_START];
    return d < f && (l = c, c = void 0), {
      corsPreFlightRequest: c,
      mainRequest: l
    };
  } else
    return {
      mainRequest: s[0]
    };
}
function Zu(e, t, r) {
  for (var n = Z(r), i = Z(ke(t)), o = e[1], a, s = e.length, u = 1; u < s; u++) {
    var c = e[u], l = Z(ke(c[m.FETCH_START])), f = Z(ke(c[m.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = c);
  }
  return o;
}
function ec(e, t, r, n, i, o) {
  var a = Z(t), s = Z(r), u = n.filter(function(c) {
    var l = Z(ke(c[m.FETCH_START])), f = Z(ke(c[m.RESPONSE_END]));
    return c.initiatorType.toLowerCase() === (o || "xmlhttprequest") && c.name === e && l >= a && f <= s;
  });
  return u.length > 0 && (u = u.filter(function(c) {
    return !i.has(c);
  })), u;
}
function K(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = Ju();
  return t.href = e, t;
}
function gi(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = rc(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += gi(e.parentNode, !1)), n += r, n;
}
function tc(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function rc(e, t) {
  var r = e.nodeType, n = tc(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function Ti(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = K(e);
  return n.origin === Ei() ? !0 : r.some(function(i) {
    return si(e, i);
  });
}
var De;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(De || (De = {}));
var nc = "0.39.0", ic = "@opentelemetry/instrumentation-document-load", pt;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(pt || (pt = {}));
var oc = function() {
  var e, t, r = {}, n = (t = (e = V).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(m);
    i.forEach(function(s) {
      if (ie(n, s)) {
        var u = n[s];
        typeof u == "number" && (r[s] = u);
      }
    });
  } else {
    var o = V, a = o.timing;
    if (a) {
      var i = Object.values(m);
      i.forEach(function(u) {
        if (ie(a, u)) {
          var c = a[u];
          typeof c == "number" && (r[u] = c);
        }
      });
    }
  }
  return r;
}, rn = {
  "first-paint": pt.FIRST_PAINT,
  "first-contentful-paint": pt.FIRST_CONTENTFUL_PAINT
}, ac = function(e) {
  var t, r, n = (r = (t = V).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    ie(rn, o) && e.addEvent(rn[o], a);
  });
}, sc = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), uc = (
  /** @class */
  function(e) {
    sc(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, ic, nc, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = V).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(s) {
        n._initResourceSpan(s, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === rt;
      }), i = oc(), o = n && n.content || "";
      R.with(j.extract(oe, { traceparent: o }), function() {
        var a, s = r._startSpan(De.DOCUMENT_LOAD, m.FETCH_START, i);
        s && (R.with(b.setSpan(R.active(), s), function() {
          var u = r._startSpan(De.DOCUMENT_FETCH, m.FETCH_START, i);
          u && (u.setAttribute(xe, location.href), R.with(b.setSpan(R.active(), u), function() {
            var c;
            r._getConfig().ignoreNetworkEvents || me(u, i), r._addCustomAttributesOnSpan(u, (c = r._getConfig().applyCustomAttributesOnSpan) === null || c === void 0 ? void 0 : c.documentFetch), r._endSpan(u, m.RESPONSE_END, i);
          }));
        }), s.setAttribute(xe, location.href), s.setAttribute(br, navigator.userAgent), r._addResourcesSpans(s), r._getConfig().ignoreNetworkEvents || (x(s, m.FETCH_START, i), x(s, m.UNLOAD_EVENT_START, i), x(s, m.UNLOAD_EVENT_END, i), x(s, m.DOM_INTERACTIVE, i), x(s, m.DOM_CONTENT_LOADED_EVENT_START, i), x(s, m.DOM_CONTENT_LOADED_EVENT_END, i), x(s, m.DOM_COMPLETE, i), x(s, m.LOAD_EVENT_START, i), x(s, m.LOAD_EVENT_END, i)), r._getConfig().ignorePerformancePaintEvents || ac(s), r._addCustomAttributesOnSpan(s, (a = r._getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(s, m.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (ie(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(De.RESOURCE_FETCH, m.FETCH_START, r, n);
      o && (o.setAttribute(xe, r.name), this._getConfig().ignoreNetworkEvents || me(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this._getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, m.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (ie(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? b.setSpan(R.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._getConfig = function() {
      return this._config;
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && ft(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      }, !0);
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && ft(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      }, !0);
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(St)
), ht;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(ht || (ht = {}));
var nn = "0.52.1", cc = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), zt, lc = 300, on = typeof process == "object" && ((zt = process.release) === null || zt === void 0 ? void 0 : zt.name) === "node", fc = (
  /** @class */
  function(e) {
    cc(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", nn, r) || this;
      return n.component = "fetch", n.version = nn, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[m.FETCH_START]
      }, b.setSpan(R.active(), r));
      this.getConfig().ignoreNetworkEvents || me(i, n), i.end(n[m.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = K(n.url);
      r.setAttribute(Kn, n.status), n.statusText != null && r.setAttribute(ht.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Wn, i.host), r.setAttribute(Yn, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(br, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!Ti(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        j.inject(R.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        j.inject(R.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (r.headers instanceof Headers)
        j.inject(R.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (r.headers instanceof Map)
        j.inject(R.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else {
        var i = {};
        j.inject(R.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), ui(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: Be.CLIENT,
        attributes: (i = {}, i[ht.COMPONENT] = this.moduleName, i[zn] = o, i[xe] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = vi(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var s = a.mainRequest;
        this._markResourceAsUsed(s);
        var u = a.corsPreFlightRequest;
        u && (this._addChildSpan(r, u), this._markResourceAsUsed(u)), this.getConfig().ignoreNetworkEvents || me(r, s);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = Q(Date.now()), s = ge();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var u;
        (u = n.observer) === null || u === void 0 || u.disconnect(), o._findResourceAndAddNetworkEvents(r, n, s), o._tasksCount--, o._clearResources(), r.end(a);
      }, lc);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var u = this, c = K(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(c, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(c);
          function h(g, O) {
            i._applyAttributesAfterFetch(g, l, O), i._endSpan(g, d, {
              status: O.status || 0,
              statusText: O.message,
              url: c
            });
          }
          function _(g, O) {
            i._applyAttributesAfterFetch(g, l, O), O.status >= 200 && O.status < 400 ? i._endSpan(g, d, O) : i._endSpan(g, d, {
              status: O.status,
              statusText: O.statusText,
              url: c
            });
          }
          function p(g, O, I) {
            try {
              var B = I.clone(), N = I.clone(), M = B.body;
              if (M) {
                var te = M.getReader(), Ge = function() {
                  te.read().then(function(Oe) {
                    var zi = Oe.done;
                    zi ? _(g, N) : Ge();
                  }, function(Oe) {
                    h(g, Oe);
                  });
                };
                Ge();
              } else
                _(g, I);
            } finally {
              O(I);
            }
          }
          function v(g, O, I) {
            try {
              h(g, I);
            } finally {
              O(I);
            }
          }
          return new Promise(function(g, O) {
            return R.with(b.setSpan(R.active(), f), function() {
              return i._addHeaders(l, c), i._tasksCount++, n.apply(u, l instanceof Request ? [l] : [c, l]).then(p.bind(u, f, g), v.bind(u, f, O));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && ft(function() {
        return a(r, n, i);
      }, function(s) {
        s && o._diag.error("applyCustomAttributesOnSpan", s);
      }, !0);
    }, t.prototype._prepareSpanData = function(r) {
      var n = ge(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var s = a.getEntries();
        s.forEach(function(u) {
          u.initiatorType === "fetch" && u.name === r && i.push(u);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (on) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      ce(fetch) && (this._unwrap(Pe, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(Pe, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      on || (this._unwrap(Pe, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(St)
), Y;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(Y || (Y = {}));
var an = "0.52.1", cr;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(cr || (cr = {}));
var dc = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), pc = 300, hc = (
  /** @class */
  function(e) {
    dc(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", an, r) || this;
      return n.component = "xml-http-request", n.version = an, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = K(n).href;
      if (!Ti(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        j.inject(R.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      j.inject(R.active(), a), Object.keys(a).forEach(function(s) {
        r.setRequestHeader(s, String(a[s]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      R.with(b.setSpan(R.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[m.FETCH_START]
        });
        i.getConfig().ignoreNetworkEvents || me(o, n), o.end(n[m.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = K(i);
        n.status !== void 0 && r.setAttribute(Kn, n.status), n.statusText !== void 0 && r.setAttribute(cr.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Wn, o.host), r.setAttribute(Yn, o.protocol.replace(":", "")), r.setAttribute(br, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && ft(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      }, !0);
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), s = K(n);
          a.forEach(function(u) {
            u.initiatorType === "xmlhttprequest" && u.name === s.href && i.createdResources && i.createdResources.entries.push(u);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (V.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var s = r.createdResources.entries;
        (!s || !s.length) && (s = V.getEntriesByType("resource"));
        var u = vi(K(i).href, o, a, s, this._usedResources);
        if (u.mainRequest) {
          var c = u.mainRequest;
          this._markResourceAsUsed(c);
          var l = u.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), this.getConfig().ignoreNetworkEvents || me(n, c);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (ui(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), s = this.tracer.startSpan(a, {
        kind: Be.CLIENT,
        attributes: (o = {}, o[zn] = i, o[xe] = K(n).toString(), o)
      });
      return s.addEvent(Y.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: s,
        spanUrl: n
      }), s;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var u = a[0], c = a[1];
          return i._createSpan(this, c, u), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(l, f, d, h) {
        var _ = f.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var p = f.span, v = f.spanUrl, g = f.sendStartTime;
        p && (r._findResourceAndAddNetworkEvents(f, p, v, g, d), p.addEvent(l, h), r._addFinalSpanAttributes(p, f, v), p.end(h), r._tasksCount--), r._clearResources();
      }
      function i(l, f) {
        var d = r._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, r._xhrMem.delete(f), d.span && r._applyAttributesAfterXHR(d.span, f);
          var h = ge(), _ = Date.now();
          setTimeout(function() {
            n(l, d, h, _);
          }, pc);
        }
      }
      function o() {
        i(Y.EVENT_ERROR, this);
      }
      function a() {
        i(Y.EVENT_ABORT, this);
      }
      function s() {
        i(Y.EVENT_TIMEOUT, this);
      }
      function u() {
        this.status < 299 ? i(Y.EVENT_LOAD, this) : i(Y.EVENT_ERROR, this);
      }
      function c(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", u), l.removeEventListener("timeout", s);
        var f = r._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, h = [], _ = 0; _ < arguments.length; _++)
            h[_] = arguments[_];
          var p = r._xhrMem.get(this);
          if (!p)
            return l.apply(this, h);
          var v = p.span, g = p.spanUrl;
          return v && g && R.with(b.setSpan(R.active(), v), function() {
            r._tasksCount++, p.sendStartTime = ge(), v.addEvent(Y.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", u), d.addEventListener("timeout", s), p.callbackToRemoveEvents = function() {
              c(d), p.createdResources && p.createdResources.observer.disconnect();
            }, r._addHeaders(d, g), r._addResourceObserver(d, g);
          }), l.apply(this, h);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), ce(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), ce(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(St)
);
function Wt(e, t) {
  if (!!!e)
    throw new Error(t);
}
function _c(e) {
  return typeof e == "object" && e !== null;
}
function Ec(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const vc = /\r\n|[\n\r]/g;
function lr(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(vc)) {
    if (typeof i.index == "number" || Ec(!1), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function gc(e) {
  return mi(
    e.source,
    lr(e.source, e.start)
  );
}
function mi(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, o = e.locationOffset.line - 1, a = t.line + o, s = t.line === 1 ? r : 0, u = t.column + s, c = `${e.name}:${a}:${u}
`, l = n.split(/\r\n|[\n\r]/g), f = l[i];
  if (f.length > 120) {
    const d = Math.floor(u / 80), h = u % 80, _ = [];
    for (let p = 0; p < f.length; p += 80)
      _.push(f.slice(p, p + 80));
    return c + sn([
      [`${a} |`, _[0]],
      ..._.slice(1, d + 1).map((p) => ["|", p]),
      ["|", "^".padStart(h)],
      ["|", _[d + 1]]
    ]);
  }
  return c + sn([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, l[i - 1]],
    [`${a} |`, f],
    ["|", "^".padStart(u)],
    [`${a + 1} |`, l[i + 1]]
  ]);
}
function sn(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function Tc(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class Ir extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, o;
    const { nodes: a, source: s, positions: u, path: c, originalError: l, extensions: f } = Tc(r);
    super(t), this.name = "GraphQLError", this.path = c != null ? c : void 0, this.originalError = l != null ? l : void 0, this.nodes = un(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const d = un(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((_) => _.loc).filter((_) => _ != null)
    );
    this.source = s != null ? s : d == null || (i = d[0]) === null || i === void 0 ? void 0 : i.source, this.positions = u != null ? u : d == null ? void 0 : d.map((_) => _.start), this.locations = u && s ? u.map((_) => lr(s, _)) : d == null ? void 0 : d.map((_) => lr(_.source, _.start));
    const h = _c(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (o = f != null ? f : h) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Ir) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + gc(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + mi(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function un(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function k(e, t, r) {
  return new Ir(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class mc {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class yi {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, o, a) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = o, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const yc = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Sc = new Set(Object.keys(yc));
function bf(e) {
  const t = e == null ? void 0 : e.kind;
  return typeof t == "string" && Sc.has(t);
}
var Ee;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Ee || (Ee = {}));
var fr;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(fr || (fr = {}));
var T;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(T || (T = {}));
function dr(e) {
  return e === 9 || e === 32;
}
function Fe(e) {
  return e >= 48 && e <= 57;
}
function Si(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Oi(e) {
  return Si(e) || e === 95;
}
function Oc(e) {
  return Si(e) || Fe(e) || e === 95;
}
function Rc(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let a = 0; a < e.length; ++a) {
    var o;
    const s = e[a], u = Ac(s);
    u !== s.length && (n = (o = n) !== null && o !== void 0 ? o : a, i = a, a !== 0 && u < r && (r = u));
  }
  return e.map((a, s) => s === 0 ? a : a.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function Ac(e) {
  let t = 0;
  for (; t < e.length && dr(e.charCodeAt(t)); )
    ++t;
  return t;
}
function Nf(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, o = n.length > 1 && n.slice(1).every((h) => h.length === 0 || dr(h.charCodeAt(0))), a = r.endsWith('\\"""'), s = e.endsWith('"') && !a, u = e.endsWith("\\"), c = s || u, l = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || c || o || a
  );
  let f = "";
  const d = i && dr(e.charCodeAt(0));
  return (l && !d || o) && (f += `
`), f += r, (l || c) && (f += `
`), '"""' + f + '"""';
}
var E;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(E || (E = {}));
class bc {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new yi(E.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== E.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = wc(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === E.COMMENT);
    return t;
  }
}
function Nc(e) {
  return e === E.BANG || e === E.DOLLAR || e === E.AMP || e === E.PAREN_L || e === E.PAREN_R || e === E.SPREAD || e === E.COLON || e === E.EQUALS || e === E.AT || e === E.BRACKET_L || e === E.BRACKET_R || e === E.BRACE_L || e === E.PIPE || e === E.BRACE_R;
}
function Se(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Ot(e, t) {
  return Ri(e.charCodeAt(t)) && Ai(e.charCodeAt(t + 1));
}
function Ri(e) {
  return e >= 55296 && e <= 56319;
}
function Ai(e) {
  return e >= 56320 && e <= 57343;
}
function de(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return E.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function P(e, t, r, n, i) {
  const o = e.line, a = 1 + r - e.lineStart;
  return new yi(t, r, n, o, a, i);
}
function wc(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return Lc(e, i);
      case 33:
        return P(e, E.BANG, i, i + 1);
      case 36:
        return P(e, E.DOLLAR, i, i + 1);
      case 38:
        return P(e, E.AMP, i, i + 1);
      case 40:
        return P(e, E.PAREN_L, i, i + 1);
      case 41:
        return P(e, E.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return P(e, E.SPREAD, i, i + 3);
        break;
      case 58:
        return P(e, E.COLON, i, i + 1);
      case 61:
        return P(e, E.EQUALS, i, i + 1);
      case 64:
        return P(e, E.AT, i, i + 1);
      case 91:
        return P(e, E.BRACKET_L, i, i + 1);
      case 93:
        return P(e, E.BRACKET_R, i, i + 1);
      case 123:
        return P(e, E.BRACE_L, i, i + 1);
      case 124:
        return P(e, E.PIPE, i, i + 1);
      case 125:
        return P(e, E.BRACE_R, i, i + 1);
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? Dc(e, i) : Cc(e, i);
    }
    if (Fe(o) || o === 45)
      return Ic(e, i, o);
    if (Oi(o))
      return Mc(e, i);
    throw k(
      e.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Se(o) || Ot(r, i) ? `Unexpected character: ${de(e, i)}.` : `Invalid character: ${de(e, i)}.`
    );
  }
  return P(e, E.EOF, n, n);
}
function Lc(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (Se(o))
      ++i;
    else if (Ot(r, i))
      i += 2;
    else
      break;
  }
  return P(
    e,
    E.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function Ic(e, t, r) {
  const n = e.source.body;
  let i = t, o = r, a = !1;
  if (o === 45 && (o = n.charCodeAt(++i)), o === 48) {
    if (o = n.charCodeAt(++i), Fe(o))
      throw k(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${de(
          e,
          i
        )}.`
      );
  } else
    i = Yt(e, i, o), o = n.charCodeAt(i);
  if (o === 46 && (a = !0, o = n.charCodeAt(++i), i = Yt(e, i, o), o = n.charCodeAt(i)), (o === 69 || o === 101) && (a = !0, o = n.charCodeAt(++i), (o === 43 || o === 45) && (o = n.charCodeAt(++i)), i = Yt(e, i, o), o = n.charCodeAt(i)), o === 46 || Oi(o))
    throw k(
      e.source,
      i,
      `Invalid number, expected digit but got: ${de(
        e,
        i
      )}.`
    );
  return P(
    e,
    a ? E.FLOAT : E.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function Yt(e, t, r) {
  if (!Fe(r))
    throw k(
      e.source,
      t,
      `Invalid number, expected digit but got: ${de(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; Fe(n.charCodeAt(i)); )
    ++i;
  return i;
}
function Cc(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, o = i, a = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return a += r.slice(o, i), P(e, E.STRING, t, i + 1, a);
    if (s === 92) {
      a += r.slice(o, i);
      const u = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? Pc(e, i) : xc(e, i) : kc(e, i);
      a += u.value, i += u.size, o = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (Se(s))
      ++i;
    else if (Ot(r, i))
      i += 2;
    else
      throw k(
        e.source,
        i,
        `Invalid character within String: ${de(
          e,
          i
        )}.`
      );
  }
  throw k(e.source, i, "Unterminated string.");
}
function Pc(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const o = r.charCodeAt(t + i++);
    if (o === 125) {
      if (i < 5 || !Se(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | Le(o), n < 0)
      break;
  }
  throw k(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function xc(e, t) {
  const r = e.source.body, n = cn(r, t + 2);
  if (Se(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (Ri(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = cn(r, t + 8);
    if (Ai(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw k(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function cn(e, t) {
  return Le(e.charCodeAt(t)) << 12 | Le(e.charCodeAt(t + 1)) << 8 | Le(e.charCodeAt(t + 2)) << 4 | Le(e.charCodeAt(t + 3));
}
function Le(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function kc(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw k(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function Dc(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, o = t + 3, a = o, s = "";
  const u = [];
  for (; o < n; ) {
    const c = r.charCodeAt(o);
    if (c === 34 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34) {
      s += r.slice(a, o), u.push(s);
      const l = P(
        e,
        E.BLOCK_STRING,
        t,
        o + 3,
        // Return a string of the lines joined with U+000A.
        Rc(u).join(`
`)
      );
      return e.line += u.length - 1, e.lineStart = i, l;
    }
    if (c === 92 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34 && r.charCodeAt(o + 3) === 34) {
      s += r.slice(a, o), a = o + 1, o += 4;
      continue;
    }
    if (c === 10 || c === 13) {
      s += r.slice(a, o), u.push(s), c === 13 && r.charCodeAt(o + 1) === 10 ? o += 2 : ++o, s = "", a = o, i = o;
      continue;
    }
    if (Se(c))
      ++o;
    else if (Ot(r, o))
      o += 2;
    else
      throw k(
        e.source,
        o,
        `Invalid character within String: ${de(
          e,
          o
        )}.`
      );
  }
  throw k(e.source, o, "Unterminated string.");
}
function Mc(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (Oc(o))
      ++i;
    else
      break;
  }
  return P(
    e,
    E.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const Uc = 10, bi = 2;
function Ni(e) {
  return Rt(e, []);
}
function Rt(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return Bc(e, t);
    default:
      return String(e);
  }
}
function Bc(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (Fc(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : Rt(n, r);
  } else if (Array.isArray(e))
    return jc(e, r);
  return Hc(e, r);
}
function Fc(e) {
  return typeof e.toJSON == "function";
}
function Hc(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > bi ? "[" + Vc(e) + "]" : "{ " + r.map(
    ([i, o]) => i + ": " + Rt(o, t)
  ).join(", ") + " }";
}
function jc(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > bi)
    return "[Array]";
  const r = Math.min(Uc, e.length), n = e.length - r, i = [];
  for (let o = 0; o < r; ++o)
    i.push(Rt(e[o], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function Vc(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const Gc = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(t, r) {
    return t instanceof r;
  } : function(t, r) {
    if (t instanceof r)
      return !0;
    if (typeof t == "object" && t !== null) {
      var n;
      const i = r.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === o) {
        const a = Ni(t);
        throw new Error(`Cannot use ${i} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class wi {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || Wt(!1, `Body must be a string. Received: ${Ni(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || Wt(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Wt(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function Xc(e) {
  return Gc(e, wi);
}
function $c(e, t) {
  return new qc(e, t).parseDocument();
}
class qc {
  constructor(t, r = {}) {
    const n = Xc(t) ? t : new wi(t);
    this._lexer = new bc(n), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(E.NAME);
    return this.node(t, {
      kind: T.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: T.DOCUMENT,
      definitions: this.many(
        E.SOF,
        this.parseDefinition,
        E.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(E.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === E.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw k(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(E.BRACE_L))
      return this.node(t, {
        kind: T.OPERATION_DEFINITION,
        operation: Ee.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let n;
    return this.peek(E.NAME) && (n = this.parseName()), this.node(t, {
      kind: T.OPERATION_DEFINITION,
      operation: r,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(E.NAME);
    switch (t.value) {
      case "query":
        return Ee.QUERY;
      case "mutation":
        return Ee.MUTATION;
      case "subscription":
        return Ee.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      E.PAREN_L,
      this.parseVariableDefinition,
      E.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: T.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(E.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(E.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(E.DOLLAR), this.node(t, {
      kind: T.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: T.SELECTION_SET,
      selections: this.many(
        E.BRACE_L,
        this.parseSelection,
        E.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(E.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(E.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: T.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(E.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(E.PAREN_L, r, E.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(E.COLON), this.node(r, {
      kind: T.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(E.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(E.NAME) ? this.node(t, {
      kind: T.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: T.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: T.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: T.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case E.BRACKET_L:
        return this.parseList(t);
      case E.BRACE_L:
        return this.parseObject(t);
      case E.INT:
        return this.advanceLexer(), this.node(r, {
          kind: T.INT,
          value: r.value
        });
      case E.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: T.FLOAT,
          value: r.value
        });
      case E.STRING:
      case E.BLOCK_STRING:
        return this.parseStringLiteral();
      case E.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: T.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: T.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: T.NULL
            });
          default:
            return this.node(r, {
              kind: T.ENUM,
              value: r.value
            });
        }
      case E.DOLLAR:
        if (t)
          if (this.expectToken(E.DOLLAR), this._lexer.token.kind === E.NAME) {
            const n = this._lexer.token.value;
            throw k(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: T.STRING,
      value: t.value,
      block: t.kind === E.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: T.LIST,
      values: this.any(E.BRACKET_L, r, E.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: T.OBJECT,
      fields: this.any(E.BRACE_L, r, E.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(E.COLON), this.node(r, {
      kind: T.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(E.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(E.AT), this.node(r, {
      kind: T.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(E.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(E.BRACKET_R), r = this.node(t, {
        kind: T.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(E.BANG) ? this.node(t, {
      kind: T.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: T.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(E.STRING) || this.peek(E.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      E.BRACE_L,
      this.parseOperationTypeDefinition,
      E.BRACE_R
    );
    return this.node(t, {
      kind: T.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(E.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: T.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: T.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: T.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(E.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      E.BRACE_L,
      this.parseFieldDefinition,
      E.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(E.COLON);
    const o = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(t, {
      kind: T.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: o,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      E.PAREN_L,
      this.parseInputValueDef,
      E.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(E.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(E.EQUALS) && (o = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(t, {
      kind: T.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: o,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: T.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: T.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(E.EQUALS) ? this.delimitedMany(E.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: T.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      E.BRACE_L,
      this.parseEnumValueDefinition,
      E.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: T.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw k(
        this._lexer.source,
        this._lexer.token.start,
        `${Ye(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: T.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      E.BRACE_L,
      this.parseInputValueDef,
      E.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === E.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      E.BRACE_L,
      this.parseOperationTypeDefinition,
      E.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: T.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: T.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: T.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: T.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: T.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: T.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: T.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(E.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(t, {
      kind: T.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: o,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(E.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(fr, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new mc(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw k(
      this._lexer.source,
      r.start,
      `Expected ${Li(t)}, found ${Ye(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === E.NAME && r.value === t)
      this.advanceLexer();
    else
      throw k(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${Ye(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === E.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t != null ? t : this._lexer.token;
    return k(
      this._lexer.source,
      r.start,
      `Unexpected ${Ye(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (t !== void 0 && r.kind !== E.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw k(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function Ye(e) {
  const t = e.value;
  return Li(e.kind) + (t != null ? ` "${t}"` : "");
}
function Li(e) {
  return Nc(e) ? `"${e}"` : e;
}
/*! js-cookie v3.0.5 | MIT */
function Ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var zc = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function pr(e, t) {
  function r(i, o, a) {
    if (typeof document != "undefined") {
      a = Ke({}, t, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var u in a)
        a[u] && (s += "; " + u, a[u] !== !0 && (s += "=" + a[u].split(";")[0]));
      return document.cookie = i + "=" + e.write(o, i) + s;
    }
  }
  function n(i) {
    if (!(typeof document == "undefined" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, s = 0; s < o.length; s++) {
        var u = o[s].split("="), c = u.slice(1).join("=");
        try {
          var l = decodeURIComponent(u[0]);
          if (a[l] = e.read(c, l), i === l)
            break;
        } catch (f) {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(i, o) {
        r(
          i,
          "",
          Ke({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return pr(this.converter, Ke({}, this.attributes, i));
      },
      withConverter: function(i) {
        return pr(Ke({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var Kt = pr(zc, { path: "/" });
let Cr = "localStorage", hr = !0;
class Wc {
  constructor() {
    S(this, "storage", {});
  }
  getItem(t) {
    var r;
    return (r = this.storage[t]) != null ? r : "";
  }
  setItem(t, r) {
    this.storage[t] = r;
  }
  removeItem(t) {
    delete this.storage[t];
  }
}
class Yc {
  getItem(t) {
    var r;
    return (r = Kt.get(t)) != null ? r : "";
  }
  setItem(t, r) {
    if (!hr)
      return;
    const n = /* @__PURE__ */ new Date();
    n.setTime(n.getTime() + 9e5), Kt.set(t, r, { expires: n });
  }
  removeItem(t) {
    hr && Kt.remove(t);
  }
}
let Kc = new Wc();
const _t = new Yc(), Pr = () => {
  try {
    switch (Cr) {
      case "localStorage":
        return window.localStorage;
      case "sessionStorage":
        return window.sessionStorage;
    }
  } catch (e) {
    return Kc;
  }
}, wf = (e) => {
  Cr = e;
}, Jc = (e) => {
  hr = e;
}, Ii = (e) => Pr().getItem(e), Ci = (e, t) => (_t.setItem(e, t), Pr().setItem(e, t)), Qc = (e) => (_t.removeItem(e), Pr().removeItem(e)), Lf = (e) => {
  if (Cr === "sessionStorage") {
    console.warn("highlight.io cannot use local storage; segment integration will not work");
    return;
  }
  const t = window.localStorage.setItem;
  window.localStorage.setItem = function() {
    const [r, n] = arguments;
    e({ keyName: r, keyValue: n }), t.apply(this, [r, n]);
  };
};
var ye;
(function(e) {
  e.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", e.SESSION_ID = "sessionID", e.SESSION_DATA = "sessionData", e.USER_IDENTIFIER = "highlightIdentifier", e.USER_OBJECT = "highlightUserObject";
})(ye || (ye = {}));
const At = (e) => `${ye.SESSION_DATA}_${e}`;
let Pi = "";
const ln = () => Pi, Zc = (e) => {
  e && (Pi = e);
}, el = () => {
  var e;
  return (e = Ii(ye.SESSION_ID)) != null ? e : "";
}, tl = (e) => {
  Ci(ye.SESSION_ID, e);
}, rl = (e) => {
  const t = At(e);
  return JSON.parse(Ii(t) || "{}");
}, Jt = (e) => {
  e || (e = el());
  let t = rl(e);
  if (t && t.lastPushTime && Date.now() - t.lastPushTime < 9e5)
    return t;
  Qc(At(e));
}, nl = function(e) {
  if (!(e != null && e.sessionSecureID))
    return;
  const t = e.sessionSecureID;
  Zc(t), Ci(At(t), JSON.stringify(e));
}, il = function() {
  const e = _t.getItem(ye.SESSION_ID);
  tl(e);
  const t = At(e), r = _t.getItem(t);
  try {
    nl(JSON.parse(r));
  } catch (n) {
  }
}, fn = (e, t, r) => {
  const n = xi(t, e.headers, r);
  return F(D({}, e), {
    headers: n
  });
}, xi = (e, t, r) => {
  var i, o;
  const n = D({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...ol, ...e].includes(a == null ? void 0 : a.toLowerCase()) && (n[a] = "[REDACTED]");
  }), n);
}, ol = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], ki = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], Di = "X-Highlight-Request", dn = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, al = (e, { headersToRedact: t, headersToRecord: r, requestResponseSanitizer: n }) => {
  var u, c;
  let i = e;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(i.response.body);
    } catch (h) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (h) {
    } finally {
      f = f && !!((u = i == null ? void 0 : i.request) != null && u.body), d = d && !!((c = i == null ? void 0 : i.response) != null && c.body), f && (i.request.body = JSON.stringify(i.request.body)), d && (i.response.body = JSON.stringify(i.response.body));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, s = It(l, ["request", "response"]);
  return D({
    request: fn(o, t, r),
    response: fn(a, t, r)
  }, s);
}, pn = (e, t, r, n) => {
  e.sort((u, c) => u.responseEnd - c.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((u, c) => {
    const l = dn(c.name);
    return c.initiatorType === r ? u[r][l] = [
      ...u[r][l] || [],
      c
    ] : u.others[l] = [
      ...u.others[l] || [],
      c
    ], u;
  }, i);
  let a = {};
  a = t.reduce((u, c) => {
    const l = dn(c.request.url);
    return u[l] = [...u[l] || [], c], u;
  }, a);
  for (let u in o[r]) {
    const c = o[r][u], l = a[u];
    if (!l)
      continue;
    const f = Math.max(c.length - l.length, 0);
    for (let d = f; d < c.length; d++)
      c[d] && (c[d].requestResponsePair = l[d - f]);
  }
  let s = [];
  for (let u in o)
    for (let c in o[u])
      s = s.concat(o[u][c]);
  return s.sort((u, c) => u.fetchStart - c.fetchStart).reduce((u, c) => {
    let l = c.requestResponsePair;
    return l && (l = al(c.requestResponsePair, n), !l) || (c.toJSON = function() {
      const f = window.performance.timeOrigin;
      return {
        initiatorType: this.initiatorType,
        startTimeAbs: f + this.startTime,
        connectStartAbs: f + this.connectStart,
        connectEndAbs: f + this.connectEnd,
        domainLookupStartAbs: f + this.domainLookupStart,
        domainLookupEndAbs: f + this.domainLookupEnd,
        fetchStartAbs: f + this.fetchStart,
        redirectStartAbs: f + this.redirectStart,
        redirectEndAbs: f + this.redirectEnd,
        requestStartAbs: f + this.requestStart,
        responseStartAbs: f + this.responseStart,
        responseEndAbs: f + this.responseEnd,
        secureConnectionStartAbs: f + this.secureConnectionStart,
        workerStartAbs: f + this.workerStart,
        name: this.name,
        transferSize: this.transferSize,
        encodedBodySize: this.encodedBodySize,
        decodedBodySize: this.decodedBodySize,
        nextHopProtocol: this.nextHopProtocol,
        requestResponsePairs: l
      };
    }, u.push(c)), u;
  }, []);
}, sl = (e, t) => e.toLocaleLowerCase().includes("https://highlight.bedsforkids.org/public") || e.toLocaleLowerCase().includes("highlight.io") || e.toLocaleLowerCase().includes(t), bt = (e, t, r) => !sl(e, t) || Nt(e, r), Nt = (e, t) => {
  var i;
  let r = [];
  t === !0 ? (r = ["localhost", /^\//], (i = window == null ? void 0 : window.location) != null && i.host && r.push(window.location.host)) : t instanceof Array && (r = t);
  let n = !1;
  return r.forEach((o) => {
    e.match(o) && (n = !0);
  }), n;
};
function ul(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(Math.floor(Math.random() * n));
  return t;
}
const xr = (e) => {
  const t = ul(10);
  if (e) {
    const r = sf(), n = r == null ? void 0 : r.spanContext().traceId;
    return [ln(), n != null ? n : t];
  }
  return [ln(), t];
}, Mi = (e, t) => e + "/" + t, cl = (e, t, r, n, i, o, a) => {
  const s = XMLHttpRequest.prototype, u = s.open, c = s.send, l = s.setRequestHeader;
  return s.open = function(f, d) {
    return typeof d == "string" ? this._url = d : this._url = d.toString(), this._method = f, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some((h) => this._url.toLowerCase().includes(h)), u.apply(this, arguments);
  }, s.setRequestHeader = function(f, d) {
    return this._requestHeaders[f] = d, l.apply(this, arguments);
  }, s.send = function(f) {
    if (!bt(this._url, t, r))
      return c.apply(this, arguments);
    const [d, h] = xr(a);
    Nt(this._url, r) && this.setRequestHeader(Di, Mi(d, h));
    const _ = this._shouldRecordHeaderAndBody, p = {
      sessionSecureID: d,
      id: h,
      url: this._url,
      verb: this._method,
      headers: _ ? this._requestHeaders : {},
      body: void 0
    };
    if (_ && f) {
      const v = hn(f, p.url);
      v && (this._body = v, p.body = ne(v, i, o, p.headers));
    }
    return this.addEventListener("load", function() {
      return H(this, null, function* () {
        const v = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (_) {
          const I = this.getAllResponseHeaders().trim().split(/[\r\n]+/), B = {};
          if (I.forEach(function(N) {
            const M = N.split(": "), te = M.shift();
            B[te] = M.join(": ");
          }), v.headers = B, f) {
            const N = hn(f, p.url);
            N && (p.body = ne(N, i, o, v.headers));
          }
          if (this.responseType === "" || this.responseType === "text")
            v.body = ne(this.responseText, i, o, v.headers), v.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const N = yield this.response.text();
                v.body = ne(N, i, o, v.headers), v.size = this.response.size;
              } catch (N) {
              }
          } else
            try {
              v.body = ne(this.response, i, o, v.headers);
            } catch (N) {
            }
        }
        e({
          request: p,
          response: v,
          urlBlocked: !_
        });
      });
    }), this.addEventListener("error", function() {
      return H(this, null, function* () {
        const v = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: p,
          response: v,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    s.open = u, s.send = c, s.setRequestHeader = l;
  };
}, hn = (e, t) => {
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && e.includes("pushPayload")))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return ot(e);
  return null;
}, _n = 64 * 1024, ll = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, ne = (e, t, r, n) => {
  var o, a, s;
  let i = _n;
  if (n) {
    let u = "";
    typeof n.get == "function" ? u = (o = n.get("content-type")) != null ? o : "" : u = (a = n["content-type"]) != null ? a : "";
    try {
      u = u.split(";")[0];
    } catch (c) {
    }
    i = (s = ll[u]) != null ? s : _n;
  }
  if (e) {
    if (t)
      try {
        const u = JSON.parse(e);
        Array.isArray(u) ? u.forEach((c) => {
          Object.keys(c).forEach((l) => {
            t.includes(l.toLocaleLowerCase()) && (c[l] = "[REDACTED]");
          });
        }) : Object.keys(u).forEach((c) => {
          t.includes(c.toLocaleLowerCase()) && (u[c] = "[REDACTED]");
        }), e = JSON.stringify(u);
      } catch (u) {
      }
    if (r)
      try {
        const u = JSON.parse(e);
        Object.keys(u).forEach((c) => {
          r.includes(c.toLocaleLowerCase()) || (u[c] = "[REDACTED]");
        }), e = JSON.stringify(u);
      } catch (u) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (u) {
  }
  return e;
}, fl = (e, t, r, n, i, o, a) => {
  const s = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: l, url: f } = dl(u, c);
    if (!bt(f, t, r))
      return s.call(this, u, c);
    const [d, h] = xr(a);
    if (Nt(f, r)) {
      c = c || {};
      let g = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(([O, I]) => g.set(O, I)), g.set(Di, Mi(d, h)), c.headers = Object.fromEntries(g.entries());
    }
    const _ = {
      sessionSecureID: d,
      id: h,
      headers: {},
      body: void 0,
      url: f,
      verb: l
    }, p = !n.some((g) => f.toLowerCase().includes(g));
    p && (_.headers = Object.fromEntries(new Headers(c == null ? void 0 : c.headers).entries()), _.body = ne(c == null ? void 0 : c.body, i, o, c == null ? void 0 : c.headers));
    let v = s.call(this, u, c);
    return pl(v, _, e, p, i, o), v;
  }, () => {
    window._fetchProxy = s;
  };
}, dl = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, pl = (e, t, r, n, i, o) => {
  const a = (s) => H(void 0, null, function* () {
    let u = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, c = !1, l = !n;
    "stack" in s || s instanceof Error ? (u = F(D({}, u), {
      body: s.message,
      status: 0,
      size: void 0
    }), c = !0) : "status" in s && (u = F(D({}, u), {
      status: s.status
    }), n && (u.body = yield Ui(s, o, i), u.headers = Object.fromEntries(s.headers.entries()), u.size = u.body.length * 8), (s.type === "opaque" || s.type === "opaqueredirect") && (l = !0, u = F(D({}, u), {
      body: "CORS blocked request"
    })), c = !0), c && r({
      request: t,
      response: u,
      urlBlocked: l
    });
  });
  e.then(a).catch(() => {
  });
}, Ui = (e, t, r) => H(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), s = new TextDecoder(), u, c = "";
      for (; !(u = yield a.read()).done; ) {
        let l = u.value;
        c += s.decode(l);
      }
      n = c, n = ne(n, r, t, e.headers);
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var hl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Bi = 1e4, _l = 5, El = 1e3, vl = 5e3, gl = 1.5;
function Tl(e) {
  e === void 0 && (e = {});
  var t = {};
  return Object.entries(e).forEach(function(r) {
    var n = hl(r, 2), i = n[0], o = n[1];
    typeof o != "undefined" ? t[i] = String(o) : y.warn('Header "' + i + '" has invalid value (' + o + ") and will be ignored");
  }), t;
}
function ml(e, t) {
  return e.endsWith("/") || (e = e + "/"), e + t;
}
function yl(e) {
  try {
    var t = new URL(e);
    return t.pathname === "" && (t.pathname = t.pathname + "/"), t.toString();
  } catch (r) {
    return y.warn("Could not parse export URL: '" + e + "'"), e;
  }
}
function Sl(e) {
  return typeof e == "number" ? e <= 0 ? Fi(e, Bi) : e : Ol();
}
function Ol() {
  var e, t = Number((e = L().OTEL_EXPORTER_OTLP_TRACES_TIMEOUT) !== null && e !== void 0 ? e : L().OTEL_EXPORTER_OTLP_TIMEOUT);
  return t <= 0 ? Fi(t, Bi) : t;
}
function Fi(e, t) {
  return y.warn("Timeout must be greater than 0", e), t;
}
function Rl(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function Al(e) {
  if (e == null)
    return -1;
  var t = Number.parseInt(e, 10);
  if (Number.isInteger(t))
    return t > 0 ? t * 1e3 : -1;
  var r = new Date(e).getTime() - Date.now();
  return r >= 0 ? r : 0;
}
var bl = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {}), this._sendingPromises = [], this.url = this.getDefaultUrl(t), typeof t.hostname == "string" && (this.hostname = t.hostname), this.shutdown = this.shutdown.bind(this), this._shutdownOnce = new Lr(this._shutdown, this), this._concurrencyLimit = typeof t.concurrencyLimit == "number" ? t.concurrencyLimit : 30, this.timeoutMillis = Sl(t.timeoutMillis), this.onInit(t);
    }
    return e.prototype.export = function(t, r) {
      if (this._shutdownOnce.isCalled) {
        r({
          code: ee.FAILED,
          error: new Error("Exporter has been shutdown")
        });
        return;
      }
      if (this._sendingPromises.length >= this._concurrencyLimit) {
        r({
          code: ee.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      this._export(t).then(function() {
        r({ code: ee.SUCCESS });
      }).catch(function(n) {
        r({ code: ee.FAILED, error: n });
      });
    }, e.prototype._export = function(t) {
      var r = this;
      return new Promise(function(n, i) {
        try {
          y.debug("items to be sent", t), r.send(t, n, i);
        } catch (o) {
          i(o);
        }
      });
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype.forceFlush = function() {
      return Promise.all(this._sendingPromises).then(function() {
      });
    }, e.prototype._shutdown = function() {
      return y.debug("shutdown started"), this.onShutdown(), this.forceFlush();
    }, e;
  }()
), Nl = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ie = (
  /** @class */
  function(e) {
    Nl(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
), Et = function() {
  return Et = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Et.apply(this, arguments);
}, wl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ll(e, t, r, n, i) {
  if (navigator.sendBeacon(t, new Blob([e], r)))
    y.debug("sendBeacon - can send", e), n();
  else {
    var o = new Ie("sendBeacon - cannot send " + e);
    i(o);
  }
}
function Il(e, t, r, n, i, o) {
  var a, s, u = !1, c = setTimeout(function() {
    if (clearTimeout(a), u = !0, s.readyState === XMLHttpRequest.DONE) {
      var f = new Ie("Request Timeout");
      o(f);
    } else
      s.abort();
  }, n), l = function(f, d) {
    f === void 0 && (f = _l), d === void 0 && (d = El), s = new XMLHttpRequest(), s.open("POST", t);
    var h = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };
    Object.entries(Et(Et({}, h), r)).forEach(function(_) {
      var p = wl(_, 2), v = p[0], g = p[1];
      s.setRequestHeader(v, g);
    }), s.send(e), s.onreadystatechange = function() {
      if (s.readyState === XMLHttpRequest.DONE && u === !1)
        if (s.status >= 200 && s.status <= 299)
          y.debug("xhr success", e), i(), clearTimeout(c), clearTimeout(a);
        else if (s.status && Rl(s.status) && f > 0) {
          var _ = void 0;
          d = gl * d, s.getResponseHeader("Retry-After") ? _ = Al(s.getResponseHeader("Retry-After")) : _ = Math.round(Math.random() * (vl - d) + d), a = setTimeout(function() {
            l(f - 1, d);
          }, _);
        } else {
          var p = new Ie("Failed to export with XHR (status: " + s.status + ")", s.status);
          o(p), clearTimeout(c), clearTimeout(a);
        }
    }, s.onabort = function() {
      if (u) {
        var _ = new Ie("Request Timeout");
        o(_);
      }
      clearTimeout(c), clearTimeout(a);
    }, s.onerror = function() {
      if (u) {
        var _ = new Ie("Request Timeout");
        o(_);
      }
      clearTimeout(c), clearTimeout(a);
    };
  };
  l();
}
var Cl = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), vt = function() {
  return vt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, vt.apply(this, arguments);
}, Pl = (
  /** @class */
  function(e) {
    Cl(t, e);
    function t(r, n, i) {
      r === void 0 && (r = {});
      var o = e.call(this, r) || this;
      return o._useXHR = !1, o._serializer = n, o._contentType = i, o._useXHR = !!r.headers || typeof navigator.sendBeacon != "function", o._useXHR ? o._headers = Object.assign({}, Tl(r.headers), Hn(L().OTEL_EXPORTER_OTLP_HEADERS)) : o._headers = {}, o;
    }
    return t.prototype.onInit = function() {
    }, t.prototype.onShutdown = function() {
    }, t.prototype.send = function(r, n, i) {
      var o = this, a;
      if (this._shutdownOnce.isCalled) {
        y.debug("Shutdown already started. Cannot send objects");
        return;
      }
      var s = (a = this._serializer.serializeRequest(r)) !== null && a !== void 0 ? a : new Uint8Array(), u = new Promise(function(l, f) {
        o._useXHR ? Il(s, o.url, vt(vt({}, o._headers), { "Content-Type": o._contentType }), o.timeoutMillis, l, f) : Ll(s, o.url, { type: o._contentType }, l, f);
      }).then(n, i);
      this._sendingPromises.push(u);
      var c = function() {
        var l = o._sendingPromises.indexOf(u);
        o._sendingPromises.splice(l, 1);
      };
      u.then(c, c);
    }, t;
  }(bl)
);
function Hi(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function xl(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function ji(e) {
  var t = Hi(e);
  return xl(t);
}
function kl(e) {
  var t = Hi(e);
  return t.toString();
}
var Dl = typeof BigInt != "undefined" ? kl : Z;
function En(e) {
  return e;
}
function Vi(e) {
  if (e !== void 0)
    return Ar(e);
}
var Ml = {
  encodeHrTime: ji,
  encodeSpanContext: Ar,
  encodeOptionalSpanContext: Vi
};
function Ul(e) {
  var t, r;
  if (e === void 0)
    return Ml;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? ji : Dl,
    encodeSpanContext: i ? En : Ar,
    encodeOptionalSpanContext: i ? En : Vi
  };
}
var Bl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Fl(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function wt(e) {
  return Object.keys(e).map(function(t) {
    return Gi(t, e[t]);
  });
}
function Gi(e, t) {
  return {
    key: e,
    value: Xi(t)
  };
}
function Xi(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(Xi) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = Bl(r, 2), i = n[0], o = n[1];
        return Gi(i, o);
      })
    }
  } : {};
}
function Hl(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: wt(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return Vl(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return jl(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function jl(e, t) {
  var r;
  return {
    attributes: e.attributes ? wt(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Vl(e, t) {
  return {
    attributes: e.attributes ? wt(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Gl(e) {
  return {
    attributes: wt(e.attributes),
    droppedAttributesCount: 0
  };
}
var Xl = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $l = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function ql(e, t) {
  var r = Ul(t);
  return {
    resourceSpans: Wl(e, r)
  };
}
function zl(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = Xl(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, s = n.get(a.resource);
      s || (s = /* @__PURE__ */ new Map(), n.set(a.resource, s));
      var u = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), c = s.get(u);
      c || (c = [], s.set(u, c)), c.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Wl(e, t) {
  for (var r = zl(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = $l(o.value, 2), s = a[0], u = a[1], c = [], l = u.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return Hl(p, t);
        });
        c.push({
          scope: Fl(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var _ = {
      resource: Gl(s),
      scopeSpans: c,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var Yl = {
  serializeRequest: function(e) {
    var t = ql(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, Kl = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), $i = "v1/traces", Jl = "http://localhost:4318/" + $i, vn = (
  /** @class */
  function(e) {
    Kl(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r, Yl, "application/json") || this;
      return n._headers = Object.assign(n._headers, Hn(L().OTEL_EXPORTER_OTLP_TRACES_HEADERS)), n;
    }
    return t.prototype.getDefaultUrl = function(r) {
      return typeof r.url == "string" ? r.url : L().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT.length > 0 ? yl(L().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT) : L().OTEL_EXPORTER_OTLP_ENDPOINT.length > 0 ? ml(L().OTEL_EXPORTER_OTLP_ENDPOINT, $i) : Jl;
    }, t;
  }(Pl)
);
class Ql extends vn {
  constructor(r) {
    super(r);
    S(this, "xhrTraceExporter");
    this.xhrTraceExporter = new vn(F(D({}, r != null ? r : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  send(r, n, i) {
    super.send(r, n, (o) => {
      o.message.toLocaleLowerCase().includes("beacon") ? this.xhrTraceExporter.send(r, n, (a) => {
        i(F(D({}, o), {
          message: `${o.message} --- [XHR retry message: ${a.message}; code: ${a.code}].`,
          code: o.code,
          data: `${o.data} --- [XHR retry data: ${a.data}].`
        }));
      }) : i(o);
    });
  }
}
const Zl = ["click", "input", "submit"];
function ef() {
  return !1;
}
class tf extends St {
  constructor(r = {}) {
    var n;
    super("user-interaction", "1.0.0", r);
    S(this, "_spansData", /* @__PURE__ */ new WeakMap());
    // for addEventListener/removeEventListener state
    S(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    S(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    S(this, "_eventNames");
    S(this, "_shouldPreventSpanCreation");
    this._eventNames = new Set((n = r == null ? void 0 : r.eventNames) != null ? n : Zl), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : ef;
  }
  init() {
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var s;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = gi(i, !0);
    try {
      const u = this.tracer.startSpan(o, {
        attributes: {
          "event.type": o,
          "event.tag": i.tagName,
          "event.xpath": a,
          "event.id": i.id,
          "event.text": (s = i.textContent) != null ? s : "",
          "event.url": window.location.href,
          "viewport.width": window.innerWidth,
          "viewport.height": window.innerHeight
        }
      }, n ? b.setSpan(R.active(), n) : void 0);
      return r instanceof MouseEvent && (u.setAttribute("event.x", r.clientX), u.setAttribute("event.y", r.clientY), u.setAttribute("event.relativeX", r.clientX / window.innerWidth), u.setAttribute("event.relativeY", r.clientY / window.innerHeight), o === "scroll" && (u.setAttribute("event.scrollX", window.scrollX), u.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, u) === !0 ? void 0 : (this._spansData.set(u, {
        taskCount: 0
      }), u);
    } catch (u) {
      this._diag.error("failed to start create new user interaction span", u);
    }
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let s = a.get(n);
    return s || (s = /* @__PURE__ */ new Map(), a.set(n, s)), s.has(r) ? !1 : (s.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const s = a.get(r);
    return s && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), s;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   */
  _patchAddEventListener() {
    const r = this;
    let n = 0;
    return (i) => function(a, s, u) {
      if (!s)
        return i.call(this, a, s, u);
      const c = u && typeof u == "object" && u.once, l = function(...f) {
        let d;
        const h = f[0];
        if ((h == null ? void 0 : h.type) === "mousemove" && Date.now() - n < 1e3 / 60)
          return i.call(this, a, s, u);
        n = Date.now(), h && (d = r._eventsSpanMap.get(h)), c && r.removePatchedListener(this, a, s);
        const _ = r._createSpan(h, d);
        return _ ? (h && r._eventsSpanMap.set(h, _), R.with(b.setSpan(R.active(), _), () => {
          const p = r._invokeListener(s, this, f);
          return _.end(), p;
        })) : r._invokeListener(s, this, f);
      };
      if (r.addPatchedListener(this, a, s, l))
        return i.call(this, a, l, u);
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, s) {
      const u = r.removePatchedListener(this, o, a);
      return u ? n.call(this, o, u, s) : n.call(this, o, a, s);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * implements enable function
   */
  enable() {
    this._getPatchableEventTargets().forEach((n) => {
      ce(n.addEventListener) && (this._unwrap(n, "addEventListener"), this._diag.debug("removing previous patch from method addEventListener")), ce(n.removeEventListener) && (this._unwrap(n, "removeEventListener"), this._diag.debug("removing previous patch from method removeEventListener")), this._wrap(n, "addEventListener", this._patchAddEventListener()), this._wrap(n, "removeEventListener", this._patchRemoveEventListener());
    });
  }
  /**
   * implements unpatch function
   */
  disable() {
    this._getPatchableEventTargets().forEach((n) => {
      ce(n.addEventListener) && this._unwrap(n, "addEventListener"), ce(n.removeEventListener) && this._unwrap(n, "removeEventListener");
    });
  }
}
var rf = { REACT_APP_PRIVATE_GRAPH_URI: "https://highlight.bedsforkids.org/private", REACT_APP_AUTH_MODE: "password", REACT_APP_PUBLIC_GRAPH_URI: "https://highlight.bedsforkids.org/public", REACT_APP_FRONTEND_URI: "https://highlight.bedsforkids.org", REACT_APP_OTLP_ENDPOINT: "https://otel.bedsforkids.org", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
let J;
const gt = "highlight.record", If = (e) => {
  var c, l, f, d, h;
  if (J !== void 0) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  const t = e.backendUrl || "https://highlight.bedsforkids.org/public", r = [
    ...(l = (c = e.networkRecordingOptions) == null ? void 0 : c.urlBlocklist) != null ? l : [],
    ...ki
  ], n = rf.DEBUG === "true", i = (f = e.endpoint) != null ? f : "https://otel.highlight.io:4318", o = (d = e.environment) != null ? d : "production";
  J = new Ku({
    resource: new ur({
      [Jn]: (h = e.serviceName) != null ? h : "highlight-browser",
      [gs]: o,
      "highlight.project_id": e.projectId,
      "highlight.session_id": e.sessionSecureId
    })
  }), n && J.addSpanProcessor(new qu(new Gu()));
  const a = new Ql({
    url: i + "/v1/traces",
    concurrencyLimit: 10,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip"
  }), s = new nf(a, {
    maxExportBatchSize: 15
  });
  J.addSpanProcessor(s), Eu({
    instrumentations: [
      new uc({
        applyCustomAttributesOnSpan: {
          documentLoad: mn,
          documentFetch: mn,
          resourceFetch: lf
        }
      }),
      new tf(),
      new fc({
        propagateTraceHeaderCorsUrls: /.*/,
        applyCustomAttributesOnSpan: (_, p, v) => H(void 0, null, function* () {
          var N, M, te;
          const g = _;
          if (g.attributes[gt] === !1)
            return;
          const O = g.attributes["http.url"], I = (N = p.method) != null ? N : "GET";
          if (_.updateName(gn(O, I, p.body)), !(v instanceof Response)) {
            _.setAttributes({
              "http.response.error": v.message,
              "http.response.status": v.status
            });
            return;
          }
          Tn(_, p.body, p.headers, e.networkRecordingOptions);
          const B = yield Ui(v, (M = e.networkRecordingOptions) == null ? void 0 : M.bodyKeysToRecord, (te = e.networkRecordingOptions) == null ? void 0 : te.networkBodyKeysToRedact);
          _.setAttribute("http.response.body", B);
        })
      }),
      new hc({
        propagateTraceHeaderCorsUrls: /.*/,
        applyCustomAttributesOnSpan: (_, p) => {
          var B, N;
          const v = p;
          if (_.attributes[gt] === !1)
            return;
          const O = gn(v._url, v._method, p.responseText);
          _.updateName(O), Tn(_, v._body, v._requestHeaders, e.networkRecordingOptions);
          const I = ne(v._body, (B = e.networkRecordingOptions) == null ? void 0 : B.networkBodyKeysToRedact, (N = e.networkRecordingOptions) == null ? void 0 : N.bodyKeysToRecord, v._requestHeaders);
          _.setAttribute("http.request.body", I);
        }
      })
    ]
  });
  const u = new _i();
  u.enable(), J.register({
    contextManager: u,
    propagator: new Zn({
      propagators: [
        new jn(),
        new of({
          backendUrl: t,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: r
        })
      ]
    })
  });
};
class nf extends hi {
  onEnd(t) {
    t.attributes[gt] !== !1 && super.onEnd(t);
  }
}
class of extends ei {
  constructor(r) {
    super();
    S(this, "backendUrl");
    S(this, "tracingOrigins");
    S(this, "urlBlocklist");
    this.backendUrl = r.backendUrl, this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    const o = b.getSpan(r);
    if (!o)
      return;
    const a = o.attributes["http.url"];
    if (typeof a == "string" && !cf(a, this.backendUrl, this.tracingOrigins, this.urlBlocklist)) {
      o.setAttribute(gt, !1);
      return;
    }
    super.inject(r, n, i);
  }
}
const af = "highlight-browser", Cf = () => J.getTracer(af), sf = () => b.getActiveSpan(), uf = () => H(void 0, null, function* () {
  J !== void 0 && (yield J.forceFlush(), J.shutdown());
}), gn = (e, t, r) => {
  var s, u, c;
  let n;
  const i = new URL(e), o = i.pathname;
  let a = `${t.toUpperCase()} - ${o}`;
  try {
    if (n = typeof r == "string" ? JSON.parse(r) : r, n && n.query) {
      const l = $c(n.query), f = ((s = l.definitions[0]) == null ? void 0 : s.kind) === "OperationDefinition" ? (c = (u = l.definitions[0]) == null ? void 0 : u.name) == null ? void 0 : c.value : void 0;
      f && (a = `${f} (GraphQL: ${i.host + i.pathname})`);
    }
  } catch (l) {
  }
  return a;
}, Tn = (e, t, r, n) => {
  var s;
  const i = typeof t == "string" ? t : String(t);
  let o;
  try {
    o = t ? JSON.parse(i) : void 0, o.operationName && e.setAttribute("graphql.operation.name", o.operationName);
  } catch (u) {
  }
  const a = xi((s = n == null ? void 0 : n.networkHeadersToRedact) != null ? s : [], r, n == null ? void 0 : n.headerKeysToRecord);
  e.setAttributes({
    "highlight.type": "http.request",
    "http.request.headers": JSON.stringify(a),
    "http.request.body": i
  });
}, cf = (e, t, r, n) => !!(n != null && n.some((a) => e.toLowerCase().includes(a))) || !bt(e, t, r) ? !1 : Nt(e, r), mn = (e) => {
  const r = e.events, n = {
    unload: G("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: G("domInteractive", "fetchStart", r),
    dom_content_loaded: G("domContentLoadedEventEnd", "domContentLoadedEventStart", r),
    dom_complete: G("fetchStart", "domComplete", r),
    load_event: G("loadEventStart", "loadEventEnd", r),
    first_paint: G("fetchStart", "firstPaint", r),
    first_contentful_paint: G("fetchStart", "firstContentfulPaint", r),
    domain_lookup: G("domainLookupStart", "domainLookupEnd", r),
    connect: G("connectStart", "connectEnd", r),
    request: G("requestStart", "requestEnd", r),
    response: G("responseStart", "responseEnd", r)
  };
  Object.entries(n).forEach(([i, o]) => {
    o > 0 && (e.setAttribute(`timings.${i}.ns`, o), e.setAttribute(`timings.${i}.readable`, qi(o)));
  });
};
function G(e, t, r) {
  const n = r.find((s) => s.name === e), i = r.find((s) => s.name === t);
  if (!n || !i)
    return 0;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const lf = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e6,
    connect: (t.connectEnd - t.connectStart) * 1e6,
    request: (t.responseEnd - t.requestStart) * 1e6,
    response: (t.responseEnd - t.responseStart) * 1e6
  };
  Object.entries(r).forEach(([n, i]) => {
    i > 0 && (e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, qi(i)));
  });
}, qi = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, ff = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var yn;
(function(e) {
  e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea";
})(yn || (yn = {}));
var Sn;
(function(e) {
  e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend";
})(Sn || (Sn = {}));
const df = (e, t, r) => {
  const n = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = e;
  const i = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (o) => {
    const f = o, { message: a, size: s } = f, u = It(f, ["message", "size"]), l = r.some((d) => o.name.toLowerCase().includes(d)) ? u : o;
    t(l);
  }, () => {
    window._highlightWebSocketRequestCallback = n, window._highlightWebSocketEventCallback = i;
  };
}, pf = ({ xhrCallback: e, fetchCallback: t, webSocketRequestCallback: r, webSocketEventCallback: n, disableWebSocketRecording: i, bodyKeysToRedact: o, backendUrl: a, tracingOrigins: s, urlBlocklist: u, bodyKeysToRecord: c, otelEnabled: l }) => {
  const f = cl(e, a, s, u, o, c, l), d = fl(t, a, s, u, o, c, l), h = i ? () => {
  } : df(r, n, u);
  return () => {
    f(), d(), h();
  };
};
class kr {
  constructor(t) {
    S(this, "disableConsoleRecording");
    S(this, "reportConsoleErrors");
    S(this, "enablePromisePatch");
    S(this, "consoleMethodsToRecord");
    S(this, "listeners");
    S(this, "errors");
    S(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    S(this, "options");
    S(this, "hasNetworkRecording", !0);
    S(this, "_backendUrl");
    S(this, "disableNetworkRecording");
    S(this, "enableRecordingNetworkContents");
    S(this, "xhrNetworkContents");
    S(this, "fetchNetworkContents");
    S(this, "disableRecordingWebSocketContents");
    S(this, "webSocketNetworkContents");
    S(this, "webSocketEventContents");
    S(this, "tracingOrigins");
    S(this, "networkHeadersToRedact");
    S(this, "networkBodyKeysToRedact");
    S(this, "networkBodyKeysToRecord");
    S(this, "networkHeaderKeysToRecord");
    S(this, "lastNetworkRequestTimestamp");
    S(this, "urlBlocklist");
    S(this, "requestResponseSanitizer");
    var r, n;
    this.options = t, this.disableConsoleRecording = !!t.disableConsoleRecording, this.reportConsoleErrors = (r = t.reportConsoleErrors) != null ? r : !1, this.enablePromisePatch = (n = t.enablePromisePatch) != null ? n : !0, this.consoleMethodsToRecord = t.consoleMethodsToRecord || [
      ...ff
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening())
      return;
    const t = this;
    this.disableConsoleRecording || this.listeners.push(ao((r) => {
      var n, i, o;
      if (this.reportConsoleErrors && (r.type === "Error" || r.type === "error") && r.value && r.trace) {
        const a = ot(r.value);
        if (Br.includes(a) || Fr.some((s) => a.includes(s)))
          return;
        t.errors.push({
          event: a,
          type: "console.error",
          url: window.location.href,
          source: (n = r.trace[0]) != null && n.fileName ? r.trace[0].fileName : "",
          lineNumber: (i = r.trace[0]) != null && i.lineNumber ? r.trace[0].lineNumber : 0,
          columnNumber: (o = r.trace[0]) != null && o.columnNumber ? r.trace[0].columnNumber : 0,
          stackTrace: r.trace,
          timestamp: (/* @__PURE__ */ new Date()).toISOString()
        });
      }
      t.messages.push(r);
    }, {
      level: this.consoleMethodsToRecord,
      logger: "console",
      stringifyOptions: {
        depthOfLimit: 10,
        numOfKeysLimit: 100,
        stringLengthLimit: 1e3
      }
    })), this.listeners.push(uo((r) => {
      Br.includes(r.event) || Fr.some((n) => r.event.includes(n)) || t.errors.push(r);
    }, { enablePromisePatch: this.enablePromisePatch })), this.options.enableOtelTracing && this.listeners.push(uf), kr.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((t) => t()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(t, r) {
    var n, i, o, a, s, u, c, l, f, d, h, _;
    t._backendUrl = (r == null ? void 0 : r.backendUrl) || "https://highlight.bedsforkids.org/public", t.xhrNetworkContents = [], t.fetchNetworkContents = [], t.webSocketNetworkContents = [], t.webSocketEventContents = [], t.networkHeadersToRedact = [], t.urlBlocklist = [], t.tracingOrigins = r.tracingOrigins || [], (r == null ? void 0 : r.disableNetworkRecording) !== void 0 ? (t.disableNetworkRecording = r == null ? void 0 : r.disableNetworkRecording, t.enableRecordingNetworkContents = !1, t.disableRecordingWebSocketContents = !0, t.networkHeadersToRedact = [], t.networkBodyKeysToRedact = [], t.urlBlocklist = [], t.networkBodyKeysToRecord = []) : typeof (r == null ? void 0 : r.networkRecording) == "boolean" ? (t.disableNetworkRecording = !r.networkRecording, t.enableRecordingNetworkContents = !1, t.disableRecordingWebSocketContents = !0, t.networkHeadersToRedact = [], t.networkBodyKeysToRedact = [], t.urlBlocklist = []) : (((n = r.networkRecording) == null ? void 0 : n.enabled) !== void 0 ? t.disableNetworkRecording = !r.networkRecording.enabled : t.disableNetworkRecording = !1, t.enableRecordingNetworkContents = ((i = r.networkRecording) == null ? void 0 : i.recordHeadersAndBody) || !1, t.disableRecordingWebSocketContents = ((o = r.networkRecording) == null ? void 0 : o.disableWebSocketEventRecordings) || !1, t.networkHeadersToRedact = ((s = (a = r.networkRecording) == null ? void 0 : a.networkHeadersToRedact) == null ? void 0 : s.map((p) => p.toLowerCase())) || [], t.networkBodyKeysToRedact = ((c = (u = r.networkRecording) == null ? void 0 : u.networkBodyKeysToRedact) == null ? void 0 : c.map((p) => p.toLowerCase())) || [], t.urlBlocklist = ((f = (l = r.networkRecording) == null ? void 0 : l.urlBlocklist) == null ? void 0 : f.map((p) => p.toLowerCase())) || [], t.urlBlocklist = [
      ...t.urlBlocklist,
      ...ki
    ], t.requestResponseSanitizer = (d = r.networkRecording) == null ? void 0 : d.requestResponseSanitizer, t.networkHeaderKeysToRecord = (h = r.networkRecording) == null ? void 0 : h.headerKeysToRecord, t.networkHeaderKeysToRecord && (t.networkHeadersToRedact = [], t.networkHeaderKeysToRecord = t.networkHeaderKeysToRecord.map((p) => p.toLocaleLowerCase())), t.networkBodyKeysToRecord = (_ = r.networkRecording) == null ? void 0 : _.bodyKeysToRecord, t.networkBodyKeysToRecord && (t.networkBodyKeysToRedact = [], t.networkBodyKeysToRecord = t.networkBodyKeysToRecord.map((p) => p.toLocaleLowerCase()))), !t.disableNetworkRecording && t.enableRecordingNetworkContents && t.listeners.push(pf({
      xhrCallback: (p) => {
        t.xhrNetworkContents.push(p);
      },
      fetchCallback: (p) => {
        t.fetchNetworkContents.push(p);
      },
      webSocketRequestCallback: (p) => {
        t.webSocketNetworkContents && t.webSocketNetworkContents.push(p);
      },
      webSocketEventCallback: (p) => {
        t.webSocketEventContents.push(p);
      },
      disableWebSocketRecording: t.disableRecordingWebSocketContents,
      bodyKeysToRedact: t.networkBodyKeysToRedact,
      backendUrl: t._backendUrl,
      tracingOrigins: t.tracingOrigins,
      urlBlocklist: t.urlBlocklist,
      bodyKeysToRecord: t.networkBodyKeysToRecord,
      otelEnabled: !!r.enableOtelTracing
    }));
  }
  static getRecordedNetworkResources(t, r) {
    var o, a;
    let n = [], i = [];
    if (!t.disableNetworkRecording) {
      const s = ((o = window == null ? void 0 : window.performance) == null ? void 0 : o.timeOrigin) || 0;
      n = performance.getEntriesByType("resource");
      const u = (r - s) * 2;
      if (n = n.filter((c) => c.responseEnd < t.lastNetworkRequestTimestamp ? !1 : bt(c.name, t._backendUrl, t.tracingOrigins)).map((c) => F(D({}, c.toJSON()), {
        offsetStartTime: c.startTime - u,
        offsetResponseEnd: c.responseEnd - u,
        offsetFetchStart: c.fetchStart - u
      })), t.lastNetworkRequestTimestamp = ((a = n.at(-1)) == null ? void 0 : a.responseEnd) || t.lastNetworkRequestTimestamp, t.enableRecordingNetworkContents) {
        const c = {
          headersToRedact: t.networkHeadersToRedact,
          headersToRecord: t.networkHeaderKeysToRecord,
          requestResponseSanitizer: t.requestResponseSanitizer
        };
        n = pn(n, t.xhrNetworkContents, "xmlhttprequest", c), n = pn(n, t.fetchNetworkContents, "fetch", c);
      }
    }
    return t.disableRecordingWebSocketContents || (i = t.webSocketNetworkContents || []), [...n, ...i];
  }
  static getRecordedWebSocketEvents(t) {
    let r = [];
    return !t.disableNetworkRecording && !t.disableRecordingWebSocketContents && (r = t.webSocketEventContents), r;
  }
  static clearRecordedNetworkResources(t) {
    t.disableNetworkRecording || (t.xhrNetworkContents = [], t.fetchNetworkContents = [], t.webSocketNetworkContents = [], t.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const hf = () => {
  var o;
  const t = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var r = "";
  const n = typeof window != "undefined" && ((o = window.crypto) == null ? void 0 : o.getRandomValues), i = new Uint32Array(28);
  n && window.crypto.getRandomValues(i);
  for (let a = 0; a < 28; a++)
    n ? r += t.charAt(i[a] % t.length) : r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}, _f = "9.3.3", Ef = () => {
  var e, t;
  typeof chrome != "undefined" && ((e = chrome == null ? void 0 : chrome.runtime) != null && e.onMessage) && ((t = chrome == null ? void 0 : chrome.runtime) == null || t.onMessage.addListener((r, n, i) => {
    const o = r.action;
    switch (console.log(`[highlight] received '${o}' event from extension.`), o) {
      case "init": {
        C.init(1, {
          debug: !0
        }), C.getSessionURL().then((a) => {
          i({ url: a });
        });
        break;
      }
      case "stop": {
        C.stop(), i({ success: !0 });
        break;
      }
    }
    return !0;
  }));
};
function Pf(e) {
  var t;
  e.on && ((t = e.webContents) != null && t.send) && (e.on("focus", () => {
    e.webContents.send("highlight.run", { visible: !0 });
  }), e.on("blur", () => {
    e.webContents.send("highlight.run", { visible: !1 });
  }), e.on("close", () => {
    e.webContents.send("highlight.run", { visible: !1 });
  }));
}
const xf = ({ next: e, payload: t }) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (t.obj.type === "track") {
      const r = t.obj.event, n = t.obj.properties;
      window.H.track(r, n);
    } else if (t.obj.type === "identify") {
      const r = t.obj.userId;
      if (r != null && r.length) {
        const n = t.obj.traits;
        window.H.identify(r, n);
      }
    }
  }
  e(t);
}, _r = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (e, t) => window._originalFetch(e, t), window._highlightFetchPatch = (e, t) => window._fetchProxy.call(window || global, e, t), window.fetch = window._highlightFetchPatch;
  }
}, On = () => null, Er = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = On, window._highlightWebSocketEventCallback = On;
    const e = new Proxy(window.WebSocket, {
      construct(t, r) {
        const [, n] = xr(), i = new t(...r), o = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "open",
            name: i.url,
            startTimeAbs: performance.timeOrigin + l.timeStamp
          });
        }, a = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "close",
            name: i.url,
            responseEndAbs: performance.timeOrigin + l.timeStamp
          }), i.removeEventListener("open", o), i.removeEventListener("error", u), i.removeEventListener("message", s), i.removeEventListener("close", a);
        }, s = (l) => {
          const { data: f } = l, d = typeof f == "string" ? l.data : void 0;
          let h;
          typeof f == "string" ? h = f.length : f instanceof Blob ? h = f.size : h = f.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: n,
            type: "received",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: h,
            message: d
          });
        }, u = (l) => {
          window._highlightWebSocketEventCallback({
            socketId: n,
            type: "error",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: 0
          });
        };
        i.addEventListener("open", o), i.addEventListener("error", u), i.addEventListener("message", s), i.addEventListener("close", a);
        const c = new Proxy(i.send, {
          apply: function(l, f, d) {
            const h = d[0], _ = typeof h == "string" ? h : void 0;
            let p;
            typeof h == "string" ? p = h.length : h instanceof Blob ? p = h.size : p = h.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: n,
              type: "sent",
              name: i.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: p,
              message: _
            }), l.apply(f, d);
          }
        });
        return i.send = c, i;
      }
    });
    window.WebSocket = e;
  }
};
var vr;
(function(e) {
  e.Device = "Device", e.WebVital = "WebVital", e.Frontend = "Frontend", e.Backend = "Backend";
})(vr || (vr = {}));
const W = (e, t) => {
  console.warn(`highlight.run warning: (${e}): `, t);
}, vf = 200;
let Je = [], Qt, X, A, Qe, Rn = !1, we;
const C = {
  options: void 0,
  init: (e, t) => {
    var r, n, i, o, a, s, u, c;
    try {
      if (C.options = t, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!e) {
        console.info("Highlight is not initializing because projectID was passed undefined.");
        return;
      }
      t != null && t.skipCookieSessionDataLoad ? Jc(!1) : il();
      let l = Jt();
      if (X = hf(), l != null && l.sessionSecureID && (X = l.sessionSecureID), Rn)
        return { sessionSecureID: X };
      Rn = !0, _r(), Er(), import("./index-5jvFKEQ0.js").then((p) => H(void 0, [p], function* ({ Highlight: d, setupBrowserTracing: h, getTracer: _ }) {
        var v, g;
        t != null && t.enableOtelTracing && (h({
          endpoint: t == null ? void 0 : t.otlpEndpoint,
          projectId: e,
          sessionSecureId: X,
          environment: (v = t == null ? void 0 : t.environment) != null ? v : "production",
          networkRecordingOptions: typeof (t == null ? void 0 : t.networkRecording) == "object" ? t.networkRecording : void 0,
          tracingOrigins: t == null ? void 0 : t.tracingOrigins,
          serviceName: (g = t == null ? void 0 : t.serviceName) != null ? g : "highlight-browser"
        }), we = _), A = new d(f, Qe), _r(), Er(), t != null && t.manualStart || (yield A.initialize());
      }));
      const f = F(D({}, t), {
        organizationID: e,
        firstloadVersion: _f,
        environment: (t == null ? void 0 : t.environment) || "production",
        appVersion: t == null ? void 0 : t.version,
        sessionSecureID: X
      });
      return Qe = new kr(f), t != null && t.manualStart || Qe.startListening(), !((n = (r = t == null ? void 0 : t.integrations) == null ? void 0 : r.mixpanel) != null && n.disabled) && ((o = (i = t == null ? void 0 : t.integrations) == null ? void 0 : i.mixpanel) != null && o.projectToken) && Qi(t.integrations.mixpanel), !((s = (a = t == null ? void 0 : t.integrations) == null ? void 0 : a.amplitude) != null && s.disabled) && ((c = (u = t == null ? void 0 : t.integrations) == null ? void 0 : u.amplitude) != null && c.apiKey) && Ji(t.integrations.amplitude), { sessionSecureID: X };
    } catch (l) {
      W("init", l);
    }
  },
  snapshot: (e) => H(void 0, null, function* () {
    try {
      if (A && A.ready)
        return yield A.snapshot(e);
    } catch (t) {
      W("snapshot", t);
    }
  }),
  addSessionFeedback: ({ verbatim: e, userName: t, userEmail: r, timestampOverride: n }) => {
    try {
      C.onHighlightReady(() => A.addSessionFeedback({
        verbatim: e,
        timestamp: n || (/* @__PURE__ */ new Date()).toISOString(),
        user_email: r,
        user_name: t
      }));
    } catch (i) {
      W("error", i);
    }
  },
  consumeError: (e, t, r) => {
    try {
      C.onHighlightReady(() => A.consumeCustomError(e, t, JSON.stringify(r)));
    } catch (n) {
      W("error", n);
    }
  },
  consume: (e, t) => {
    try {
      C.onHighlightReady(() => A.consumeError(e, t));
    } catch (r) {
      W("error", r);
    }
  },
  error: (e, t) => {
    try {
      C.onHighlightReady(() => A.pushCustomError(e, JSON.stringify(t)));
    } catch (r) {
      W("error", r);
    }
  },
  track: (e, t = {}) => {
    var r, n, i, o, a, s, u, c, l, f, d;
    try {
      C.onHighlightReady(() => A.addProperties(F(D({}, t), { event: e })));
      const h = A == null ? void 0 : A.getCurrentSessionURL();
      (i = (n = (r = C.options) == null ? void 0 : r.integrations) == null ? void 0 : n.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.track && window.mixpanel.track(e, F(D({}, t), {
        highlightSessionURL: h
      })), (u = (s = (a = C.options) == null ? void 0 : a.integrations) == null ? void 0 : s.amplitude) != null && u.disabled || (c = window.amplitude) != null && c.getInstance && window.amplitude.getInstance().logEvent(e, F(D({}, t), {
        highlightSessionURL: h
      })), (d = (f = (l = C.options) == null ? void 0 : l.integrations) == null ? void 0 : f.intercom) != null && d.disabled || window.Intercom && window.Intercom("trackEvent", e, t);
    } catch (h) {
      W("track", h);
    }
  },
  start: (e) => {
    (A == null ? void 0 : A.state) === "Recording" && !(e != null && e.forceNew) ? e != null && e.silent || console.warn("Highlight is already recording. Please `H.stop()` the current session before starting a new one.") : (Qe.startListening(), C.onHighlightReady(() => H(void 0, null, function* () {
      yield A.initialize(e);
    }), { waitForReady: !1 }));
  },
  stop: (e) => {
    (A == null ? void 0 : A.state) !== "Recording" ? e != null && e.silent || console.warn("Highlight is already stopped. Please call `H.start()`.") : C.onHighlightReady(() => A.stopRecording(!0));
  },
  identify: (e, t = {}) => {
    var r, n, i, o, a, s, u, c;
    try {
      C.onHighlightReady(() => A.identify(e, t));
    } catch (l) {
      W("identify", l);
    }
    if ((i = (n = (r = C.options) == null ? void 0 : r.integrations) == null ? void 0 : n.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.identify && (window.mixpanel.identify(typeof (t == null ? void 0 : t.email) == "string" ? t == null ? void 0 : t.email : e), t && (window.mixpanel.track("identify", t), window.mixpanel.people.set(t))), !((u = (s = (a = C.options) == null ? void 0 : a.integrations) == null ? void 0 : s.amplitude) != null && u.disabled) && (c = window.amplitude) != null && c.getInstance && (window.amplitude.getInstance().setUserId(e), Object.keys(t).length > 0)) {
      const l = Object.keys(t).reduce((f, d) => (f.set(d, t[d]), f), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(l);
    }
  },
  metrics: (e) => {
    try {
      C.onHighlightReady(() => A.recordMetric(e.map((t) => F(D({}, t), {
        category: vr.Frontend
      }))));
    } catch (t) {
      W("metrics", t);
    }
  },
  startSpan: (e, t, r, n) => {
    const i = typeof we == "function" ? we() : void 0;
    if (!i) {
      n === void 0 && r === void 0 ? t() : n === void 0 ? r() : n();
      return;
    }
    const o = (a, s) => H(void 0, null, function* () {
      try {
        return yield s(a);
      } finally {
        a.end();
      }
    });
    return n === void 0 && r === void 0 ? i.startActiveSpan(e, (a) => o(a, t)) : n === void 0 ? i.startActiveSpan(e, t, (a) => o(a, r)) : i.startActiveSpan(e, t, r, (a) => o(a, n));
  },
  startManualSpan: (e, t, r, n) => {
    if (typeof we != "function")
      return;
    const i = we();
    return n === void 0 && r === void 0 ? i.startActiveSpan(e, t) : n === void 0 ? i.startActiveSpan(e, t, r) : i.startActiveSpan(e, t, r, n);
  },
  getSessionURL: () => H(void 0, null, function* () {
    const e = Jt(X);
    if (e)
      return `https://${eo}/${e.projectID}/sessions/${X}`;
    throw new Error(`Unable to get session URL: ${X}}`);
  }),
  getSessionDetails: () => H(void 0, null, function* () {
    const e = yield C.getSessionURL(), t = Jt(X);
    if (!e)
      throw new Error("Could not get session URL");
    const r = t == null ? void 0 : t.sessionStartTime;
    if (!r)
      throw new Error("Could not get session start timestamp");
    const n = (/* @__PURE__ */ new Date()).getTime(), i = new URL(e), o = new URL(e);
    return o.searchParams.set(
      "ts",
      // The delta between when the session recording started and now.
      ((n - r) / 1e3).toString()
    ), {
      url: i.toString(),
      urlWithTimestamp: o.toString()
    };
  }),
  getRecordingState: () => {
    var e;
    return (e = A == null ? void 0 : A.state) != null ? e : "NotRecording";
  },
  onHighlightReady: (e, t) => {
    if (Je.push({ options: t, func: e }), Qt === void 0) {
      const r = () => {
        var i;
        const n = [];
        for (const o of Je)
          A && (((i = o.options) == null ? void 0 : i.waitForReady) === !1 || A.ready) ? o.func() : n.push(o);
        Je = n, Qt = void 0, Je.length > 0 && (Qt = setTimeout(r, vf));
      };
      r();
    }
  }
};
typeof window != "undefined" && (window.H = C);
Ef();
_r();
Er();
export {
  C as A,
  xf as B,
  vr as C,
  it as E,
  kr as F,
  hf as G,
  eo as H,
  T as K,
  yn as M,
  yc as Q,
  ye as S,
  Of as V,
  Ni as a,
  $c as b,
  An as c,
  Wt as d,
  Ii as e,
  Jt as f,
  bn as g,
  Rf as h,
  bf as i,
  tl as j,
  nl as k,
  Tf as l,
  Lf as m,
  Sn as n,
  yf as o,
  Nf as p,
  mf as q,
  Qc as r,
  Ci as s,
  ot as t,
  Sf as u,
  wf as v,
  Jc as w,
  Cf as x,
  If as y,
  Pf as z
};
//# sourceMappingURL=index-Y1R8ZyCE.js.map
